function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c9c9c9;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#drop-shadow-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#drop-shadow-6);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #a3a3a3;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #6cb33f;\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#drop-shadow-5);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #99aacf;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #183e6d;\r\n      }\r\n\r\n      .cls-11, .cls-12, .cls-13, .cls-14 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#radial-gradient-5);\r\n      }\r\n\r\n      .cls-16 {\r\n        filter: url(#drop-shadow-4);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#radial-gradient-3);\r\n      }\r\n\r\n      .cls-19 {\r\n        filter: url(#drop-shadow-1);\r\n      }\r\n\r\n      .cls-12 {\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-12, .cls-13, .cls-14 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-13 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-13, .cls-14 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #9ba2b1;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#radial-gradient-8);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#radial-gradient-2);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #81be5a;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#radial-gradient-4);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #eff1f7;\r\n      }\r\n\r\n      .cls-14 {\r\n        stroke: #636466;\r\n      }\r\n\r\n      .cls-26 {\r\n        filter: url(#drop-shadow-3);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #9bcb7c;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#radial-gradient-6);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#radial-gradient-7);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: rgba(255, 255, 255, 0);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("symbol", {
  id: "Tree_1",
  "data-name": "Tree 1",
  viewBox: "0 0 60.97 60.42"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M20.78,7.97c.25-2.06,1.43-4.05,3.26-5.02,1.84-.97,4.31-.73,5.75.76,1.26-1.72,3.12-3.11,5.23-3.38,2.12-.27,4.46.78,5.3,2.75,3.1.6,5.17,4.33,4.03,7.28-.17.44-.4.87-.51,1.33-.1.42-.1.86-.16,1.3-.18,1.27-.9,2.41-1.74,3.39-1.91,2.21-4.5,3.76-7.25,4.74-2.93,1.04-6.24,1.43-9.1.21-2.33-1-4.31-3.35-4.45-5.95-.05-.92.26-1.79.2-2.71-.1-1.62-.77-2.99-.56-4.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M23.51,17.61c-.1-1.62-.77-2.99-.56-4.68.25-2.06,1.43-4.05,3.26-5.02,1.84-.97,4.31-.73,5.75.76,1.26-1.72,3.12-3.11,5.23-3.38,2.12-.27,4.46.78,5.3,2.75.79.15,1.51.51,2.13,1,.39-2.73-1.55-5.72-4.3-6.25-.84-1.96-3.18-3.02-5.3-2.75-2.12.27-3.97,1.66-5.23,3.38-1.44-1.5-3.92-1.73-5.75-.76-1.84.97-3.01,2.96-3.26,5.02-.21,1.69.46,3.06.56,4.68.06.92-.25,1.79-.2,2.71.09,1.69.96,3.27,2.19,4.45.07-.64.21-1.27.17-1.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M52.46,49.84c2.64-.27,4.9-2.87,4.53-5.5,1.76-.23,3.33-1.58,3.82-3.28.49-1.71-.13-3.68-1.51-4.8,1.25-.77,1.56-2.57.99-3.92-.57-1.35-1.83-2.3-3.15-2.94-3.88-1.87-8.77-1.42-12.25,1.13-.33.25-.66.51-1.04.68-.48.21-1.02.26-1.52.41-2.03.61-3.19,2.86-3.21,4.98-.02,2.11.85,4.12,1.73,6.05,1.08,2.38,3.28,2.3,5.17,3.69,2.14,1.58,3.38,3.82,6.45,3.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M59.3,36.23c1.25-.77,1.56-2.57.99-3.92-.57-1.35-1.83-2.3-3.15-2.94-1.22-.59-2.53-.95-3.88-1.08,1.05.62,1.98,1.46,2.45,2.57.57,1.35.26,3.15-.99,3.92,1.38,1.12,1.99,3.1,1.51,4.8-.49,1.71-2.05,3.06-3.82,3.28.36,2.49-1.66,4.95-4.12,5.43,1.12.97,2.31,1.71,4.16,1.52,2.64-.27,4.9-2.87,4.53-5.5,1.76-.23,3.33-1.58,3.82-3.28.49-1.71-.13-3.68-1.51-4.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M2.91,34.47c-.97,1.79-.74,4.15.54,5.72-1.73,1.56-2.79,3.83-2.89,6.16-.08,1.94.65,4.08,2.36,4.98,1.66.87,3.67.35,5.47-.18-.54,1.14-.25,2.56.52,3.56.77,1,1.95,1.62,3.16,1.97,1.7.48,3.58.45,5.17-.32,1.59-.77,2.83-2.34,2.97-4.1,1.58.71,3.51.29,4.89-.76,1.38-1.05,2.27-2.63,2.8-4.28.66-2.02.84-4.25.18-6.27-.66-2.02-2.22-3.8-4.26-4.42.3-1.18.59-2.49.04-3.58-.52-1.02-1.64-1.56-2.7-2-2.28-.95-4.68-1.77-7.14-1.76-2.71.01-3.86,1.38-6.05,2.46-1.93.95-3.81.47-5.09,2.83Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M23.85,33.68c.1.03.21.07.31.1-.03-.22-.09-.43-.18-.64-.04.18-.09.36-.13.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M27.92,44.38c-.54,1.65-1.42,3.23-2.8,4.28-1.38,1.05-3.31,1.46-4.89.76-.15,1.76-1.38,3.33-2.97,4.1-1.59.77-3.47.8-5.17.32-1.22-.34-2.39-.97-3.16-1.97-.77-1-1.06-2.42-.52-3.56-1.79.53-3.81,1.05-5.47.18-1.23-.64-1.95-1.92-2.23-3.31-.07.39-.11.78-.13,1.17-.08,1.94.65,4.08,2.36,4.98,1.66.87,3.67.35,5.47-.18-.54,1.14-.25,2.56.52,3.56.77,1,1.95,1.62,3.16,1.97,1.7.48,3.58.45,5.17-.32,1.59-.77,2.83-2.34,2.97-4.1,1.58.71,3.51.29,4.89-.76,1.38-1.05,2.27-2.63,2.8-4.28.52-1.59.74-3.31.49-4.95-.1.72-.27,1.43-.49,2.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M3.45,37.36c-.45-.55-.77-1.19-.95-1.87-.26.93-.25,1.94.01,2.87.29-.36.6-.69.94-1Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M5.02,10.86c-.49.5-1,1.06-1.12,1.75-.13.69.3,1.53,1.01,1.58C2.41,15.23.53,17.61.11,20.27c-.22,1.4-.07,2.83.21,4.22.29,1.44,1.1,3.15,2.57,3.1.31-.01.62-.11.91-.03.67.17.82,1.02.98,1.7.47,2.11,2.23,3.87,4.34,4.35,2.1.48,4.45-.35,5.79-2.05.2-.25.39-.53.69-.64.47-.17.96.16,1.38.43,1.97,1.26,4.54,1.55,6.74.75,2.2-.8,3.99-2.67,4.69-4.9,2.25-1.5,3.58-4.29,3.32-6.98-.26-2.69-2.1-5.18-4.6-6.21.98-.89,1.18-2.45.68-3.68-.5-1.23-1.59-2.15-2.79-2.72-1.42-.67-3.04-.91-4.59-.68-.49.07-.98.19-1.47.15-.49-.04-.95-.24-1.42-.38-2.22-.7-4.76-.23-6.65,1.12-1.08.77-1.34,1.17-2.46,1.43-1.42.32-2.29.5-3.4,1.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M31.72,20.2c-.2-2.02-1.28-3.93-2.87-5.19.18.53.31,1.09.36,1.65.26,2.69-1.06,5.48-3.32,6.98-.7,2.24-2.49,4.1-4.69,4.9-2.2.8-4.77.51-6.74-.75-.42-.27-.91-.6-1.38-.43-.3.11-.5.39-.69.64-1.34,1.69-3.68,2.52-5.79,2.05-.65-.15-1.27-.42-1.82-.78.48,2.1,2.23,3.85,4.33,4.32,2.11.48,4.45-.35,5.79-2.05.2-.25.39-.53.69-.64.47-.17.96.16,1.38.43,1.97,1.26,4.54,1.55,6.74.75,2.2-.8,3.99-2.67,4.69-4.9,2.25-1.5,3.58-4.29,3.32-6.98Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M6.81,17.31c-1.92.09-3.4,2.21-3.01,4.09s2.37,3.22,4.29,3.09c.64-.04,1.32-.26,1.7-.78.28-.4.35-.91.37-1.4.04-.85,0-1.7-.15-2.54,1.3.1,2.61-.77,3.03-2,.32-.93.34-2.22,1.28-2.51.53-.16,1.1.12,1.66.07.74-.07,1.29-.73,1.65-1.38.35-.64.62-1.43.3-2.09-.44-.93-1.69-1.06-2.72-1.05-1.52,0-3.05.02-4.57.02-2.27.01-2.2.88-2.89,2.55-.55,1.31-2.04,2.31-.93,3.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M31.4,31.72c-.7.07-1.44.19-1.98.64s-.74,1.37-.23,1.86c-2.58-.79-5.55-.14-7.57,1.64-1.06.94-1.85,2.14-2.52,3.39-.69,1.29-1.15,3.14.01,4.02.24.19.55.31.73.56.41.56-.01,1.31-.33,1.93-.97,1.93-.74,4.4.59,6.11,1.32,1.71,3.66,2.56,5.77,2.1.31-.07.64-.16.94-.05.47.17.64.73.79,1.21.72,2.23,2.52,4.08,4.73,4.87,2.21.78,4.77.48,6.74-.81,2.69.28,5.49-1.04,7-3.28s1.67-5.33.4-7.72c1.33-.06,2.46-1.14,2.86-2.41.39-1.27.14-2.67-.42-3.87-.67-1.42-1.76-2.63-3.11-3.44-.42-.25-.87-.47-1.23-.82-.35-.34-.59-.79-.85-1.2-1.27-1.95-3.53-3.2-5.84-3.36-1.32-.09-1.78.06-2.81-.46-1.3-.65-2.09-1.07-3.66-.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M46.08,55.9c1.13-1.69,1.51-3.85,1.08-5.83-.2.53-.45,1.03-.77,1.5-1.51,2.25-4.31,3.56-7,3.28-1.96,1.28-4.53,1.59-6.74.81s-4.01-2.64-4.73-4.87c-.15-.48-.32-1.04-.79-1.21-.3-.11-.63-.02-.94.05-2.11.46-4.45-.39-5.77-2.1-.41-.53-.71-1.13-.91-1.76-.96,1.92-.72,4.39.6,6.09,1.32,1.71,3.66,2.56,5.77,2.1.31-.07.64-.16.94-.05.47.17.64.73.79,1.21.72,2.23,2.52,4.08,4.73,4.87,2.21.78,4.77.48,6.74-.81,2.69.28,5.49-1.04,7-3.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M29.33,40.15c-1.54-1.15-4.03-.46-4.93,1.25-.9,1.7-.21,4,1.35,5.12.52.38,1.19.64,1.81.47.47-.13.85-.48,1.18-.85.57-.63,1.08-1.32,1.5-2.06.94.9,2.5,1.06,3.61.38.84-.52,1.67-1.5,2.58-1.12.51.21.77.8,1.23,1.11.62.42,1.46.26,2.15-.02.68-.27,1.39-.71,1.56-1.42.25-1-.63-1.89-1.43-2.54-1.18-.96-2.36-1.93-3.55-2.89-1.76-1.43-2.25-.72-3.86.13-1.26.67-3.04.49-3.21,2.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M40.25,8.85c-.7.07-1.44.19-1.98.64-.54.46-.74,1.37-.23,1.86-2.58-.79-5.55-.14-7.57,1.64-1.06.94-1.85,2.14-2.52,3.39-.69,1.29-1.15,3.14.01,4.02.24.19.55.31.73.56.41.56-.01,1.31-.33,1.93-.97,1.93-.74,4.4.59,6.11,1.32,1.71,3.66,2.56,5.77,2.1.31-.07.64-.16.94-.05.47.17.64.73.79,1.21.72,2.23,2.52,4.08,4.73,4.87,2.21.78,4.77.48,6.74-.81,2.69.28,5.49-1.04,7-3.28,1.51-2.25,1.67-5.33.4-7.72,1.33-.06,2.46-1.14,2.86-2.41.39-1.27.14-2.67-.42-3.87-.67-1.42-1.76-2.64-3.11-3.44-.42-.25-.87-.47-1.23-.82-.35-.34-.59-.79-.85-1.2-1.27-1.95-3.53-3.2-5.84-3.36-1.32-.09-1.78.06-2.81-.46-1.3-.65-2.09-1.07-3.66-.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M54.93,33.04c1.13-1.69,1.51-3.85,1.08-5.83-.2.53-.45,1.03-.77,1.5-1.51,2.25-4.31,3.56-7,3.28-1.96,1.28-4.53,1.59-6.74.81-2.21-.78-4.01-2.64-4.73-4.87-.15-.48-.32-1.04-.79-1.21-.3-.11-.63-.02-.94.05-2.11.46-4.45-.39-5.77-2.1-.41-.53-.71-1.13-.91-1.76-.96,1.92-.72,4.39.6,6.09,1.32,1.71,3.66,2.56,5.77,2.1.31-.07.64-.16.94-.05.47.17.64.73.79,1.21.72,2.23,2.52,4.08,4.73,4.87,2.21.78,4.77.48,6.74-.81,2.69.28,5.49-1.04,7-3.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M37.53,14.97c-1.54-1.15-4.03-.46-4.93,1.25s-.21,4,1.35,5.12c.52.38,1.19.64,1.81.47.47-.13.85-.48,1.18-.85.57-.63,1.08-1.32,1.5-2.06.94.9,2.5,1.06,3.61.38.84-.52,1.67-1.5,2.58-1.12.51.21.77.8,1.23,1.11.62.42,1.46.26,2.15-.02.68-.27,1.39-.71,1.57-1.42.25-1-.63-1.89-1.43-2.54-1.18-.96-2.36-1.93-3.55-2.89-1.76-1.43-2.25-.72-3.86.13-1.26.67-3.04.49-3.21,2.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M13.68,26.2c-.79.49-1.55,1.07-2.04,1.86-1.04,1.7-.49,3.89.18,5.77-2.34.8-3.03,4.2-1.55,6.18,1.48,1.98,4.4,2.48,6.73,1.66,1.65,1.65,4.06,2.51,6.38,2.29,2.32-.23,4.52-1.53,5.82-3.47.26-.39.53-.84.97-1.01.37-.14.78-.06,1.18-.04,1.33.06,2.62-.7,3.41-1.77s1.15-2.42,1.23-3.75c.04-.66.02-1.34.22-1.97.14-.46.39-.88.58-1.33.72-1.73.35-3.82-.78-5.31-1.13-1.49-2.96-2.39-4.83-2.54-.98-1.87-2.97-3.18-5.08-3.32-3.11-.21-4.2,1.63-5.99,3.59-1.49,1.63-4.47,1.95-6.43,3.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M15.29,37.05c-.68-1.89-1.22-4.09-.18-5.8.48-.8,1.26-1.37,2.04-1.87,1.97-1.24,4.97-1.56,6.46-3.2,1.79-1.97,2.88-3.82,6.01-3.61,2.12.14,4.12,1.45,5.1,3.34.8.07,1.6.27,2.33.6-.19-.69-.51-1.34-.94-1.9-1.14-1.5-2.97-2.4-4.85-2.56-.98-1.89-2.98-3.2-5.1-3.34-3.13-.21-4.22,1.64-6.01,3.61-1.49,1.64-4.49,1.96-6.46,3.2-.79.5-1.56,1.07-2.04,1.87-1.04,1.71-.49,3.92.18,5.8-2.35.81-3.04,4.22-1.55,6.22.67.9,1.63,1.49,2.69,1.8-.16-1.74.67-3.59,2.31-4.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M36.01,25.36c-.19-.25-.4-.48-.62-.69.04.75-.07,1.5-.36,2.2-.19.45-.44.87-.58,1.33-.2.63-.18,1.31-.22,1.97-.08,1.33-.44,2.68-1.23,3.75-.79,1.07-2.08,1.83-3.41,1.77-.4-.02-.81-.1-1.18.04-.44.17-.7.61-.97,1.01-1.3,1.94-3.5,3.24-5.82,3.47-2.32.23-4.73-.64-6.38-2.29-1.88.67-4.15.47-5.73-.68-.07,1,.17,2.02.77,2.82,1.48,1.98,4.4,2.48,6.73,1.66,1.65,1.65,4.06,2.51,6.38,2.29,2.32-.23,4.52-1.53,5.82-3.47.26-.39.53-.84.97-1.01.37-.14.78-.06,1.18-.04,1.33.06,2.62-.7,3.41-1.77.79-1.07,1.15-2.42,1.23-3.75.04-.66.02-1.34.22-1.97.14-.46.39-.88.58-1.33.72-1.73.35-3.82-.78-5.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M29.14,23.29c-1.77.74-3.41,2.01-4.1,3.79-.69,1.79-.14,4.11,1.54,5.03-.11,1.22-.18,2.58.59,3.53.69.85,1.86,1.13,2.95,1.23,1.68.17,3.74-.16,4.42-1.71,1.22,1.09,3,1.52,4.58,1.08,1.58-.43,2.9-1.71,3.38-3.27.17-.54.24-1.11.49-1.62.17-.34.41-.64.59-.97.55-.98.54-2.24-.02-3.22-.55-.97-1.64-1.63-2.76-1.66-.07-1.27-.85-2.48-1.98-3.07-1.45-.77-2.68-.11-4.11,0-1.98.17-3.68.04-5.6.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M43.58,27.17c-.35-.61-.89-1.09-1.53-1.37-.07.28-.17.54-.31.79-.18.33-.42.63-.59.97-.25.51-.33,1.08-.49,1.62-.49,1.56-1.8,2.84-3.38,3.27-1.58.43-3.36.01-4.58-1.08-.68,1.55-2.73,1.88-4.42,1.71-.58-.06-1.19-.16-1.74-.38-.06,1.05-.01,2.15.64,2.95.69.85,1.86,1.13,2.95,1.23,1.68.17,3.74-.16,4.42-1.71,1.22,1.09,3,1.52,4.58,1.08,1.58-.43,2.89-1.71,3.38-3.27.17-.54.24-1.11.49-1.62.17-.34.41-.64.59-.97.55-.98.54-2.24-.02-3.22Z"
}))), /*#__PURE__*/React.createElement("symbol", {
  id: "Tree_1_Small",
  "data-name": "Tree 1 Small",
  viewBox: "0 0 44.68 44.27"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M15.23,5.84c.18-1.51,1.04-2.97,2.39-3.68,1.35-.71,3.16-.54,4.22.56.92-1.26,2.28-2.28,3.83-2.48,1.55-.2,3.27.57,3.88,2.01,2.27.44,3.79,3.17,2.96,5.33-.13.32-.29.63-.38.97-.08.31-.07.63-.12.95-.13.93-.66,1.77-1.28,2.48-1.4,1.62-3.3,2.76-5.31,3.47-2.15.76-4.58,1.05-6.67.15-1.71-.73-3.16-2.45-3.26-4.36-.04-.67.19-1.31.15-1.99-.07-1.19-.56-2.19-.41-3.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M17.23,12.9c-.07-1.19-.56-2.19-.41-3.43.18-1.51,1.04-2.97,2.39-3.68,1.35-.71,3.16-.54,4.22.56.92-1.26,2.28-2.28,3.83-2.48,1.55-.2,3.27.57,3.88,2.01.58.11,1.11.37,1.56.74.29-2-1.13-4.19-3.15-4.58C28.94.6,27.22-.17,25.67.03c-1.55.2-2.91,1.21-3.83,2.48-1.05-1.1-2.87-1.27-4.22-.56-1.35.71-2.2,2.17-2.39,3.68-.15,1.23.34,2.24.41,3.43.04.67-.18,1.32-.15,1.99.06,1.24.7,2.4,1.61,3.26.05-.47.15-.93.12-1.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M38.44,36.52c1.93-.2,3.59-2.1,3.32-4.03,1.29-.17,2.44-1.15,2.8-2.41.36-1.25-.1-2.7-1.1-3.52.91-.56,1.15-1.88.73-2.87-.42-.99-1.34-1.68-2.31-2.15-2.84-1.37-6.43-1.04-8.97.83-.25.18-.48.38-.76.5-.35.16-.75.19-1.12.3-1.48.44-2.34,2.1-2.35,3.65-.01,1.55.62,3.02,1.27,4.43.79,1.74,2.41,1.69,3.79,2.7,1.57,1.16,2.48,2.8,4.73,2.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M43.45,26.55c.91-.56,1.15-1.88.73-2.87-.42-.99-1.34-1.68-2.31-2.15-.89-.43-1.86-.69-2.84-.79.77.45,1.45,1.07,1.8,1.88.42.99.19,2.31-.73,2.87,1.01.82,1.46,2.27,1.1,3.52-.36,1.25-1.5,2.24-2.8,2.41.26,1.82-1.22,3.63-3.02,3.98.82.71,1.69,1.25,3.05,1.11,1.93-.2,3.59-2.1,3.32-4.03,1.29-.17,2.44-1.15,2.8-2.41.36-1.25-.1-2.7-1.1-3.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M2.13,25.26c-.71,1.31-.54,3.04.4,4.19-1.26,1.14-2.04,2.81-2.11,4.51-.06,1.42.47,2.99,1.73,3.65,1.22.64,2.69.26,4.01-.13-.4.84-.18,1.88.38,2.61.56.73,1.43,1.19,2.32,1.44,1.25.35,2.63.33,3.79-.23,1.16-.56,2.07-1.71,2.18-3,1.16.52,2.57.21,3.58-.55,1.01-.77,1.66-1.93,2.05-3.14.48-1.48.61-3.11.13-4.6-.48-1.48-1.63-2.79-3.12-3.24.22-.87.43-1.83.03-2.62-.38-.75-1.2-1.14-1.98-1.47-1.67-.7-3.43-1.3-5.24-1.29-1.99.01-2.83,1.01-4.43,1.8-1.41.7-2.79.35-3.73,2.07Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M17.47,24.68c.08.02.15.05.22.08-.03-.16-.07-.32-.13-.47-.03.13-.06.26-.1.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M20.46,32.52c-.39,1.21-1.04,2.37-2.05,3.14-1.01.77-2.43,1.07-3.58.55-.11,1.29-1.01,2.44-2.18,3-1.16.56-2.55.59-3.79.23-.89-.25-1.75-.71-2.32-1.44-.56-.73-.78-1.78-.38-2.61-1.32.39-2.79.77-4.01.13-.9-.47-1.43-1.41-1.64-2.43-.05.28-.08.57-.1.86-.06,1.42.47,2.99,1.73,3.65,1.22.64,2.69.26,4.01-.13-.4.84-.18,1.88.38,2.61.56.73,1.43,1.19,2.32,1.44,1.25.35,2.63.33,3.79-.23,1.16-.56,2.07-1.71,2.18-3,1.16.52,2.57.21,3.58-.55,1.01-.77,1.66-1.93,2.05-3.14.38-1.17.54-2.42.36-3.63-.07.53-.2,1.05-.36,1.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M2.53,27.37c-.33-.4-.56-.87-.7-1.37-.19.68-.18,1.42,0,2.11.21-.26.44-.51.69-.73Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M3.68,7.96c-.36.37-.73.78-.82,1.29-.09.51.22,1.12.74,1.16C1.77,11.16.39,12.9.08,14.85c-.16,1.02-.05,2.07.15,3.09.21,1.05.81,2.31,1.88,2.27.22,0,.45-.08.67-.02.49.13.6.75.72,1.24.35,1.54,1.64,2.83,3.18,3.18,1.54.35,3.26-.26,4.24-1.5.14-.18.29-.39.51-.47.34-.12.7.12,1.01.31,1.45.93,3.33,1.14,4.94.55,1.61-.59,2.92-1.96,3.44-3.59,1.65-1.1,2.62-3.14,2.43-5.12-.19-1.97-1.54-3.79-3.37-4.55.72-.65.86-1.79.5-2.69-.37-.9-1.16-1.57-2.04-1.99-1.04-.49-2.22-.67-3.36-.5-.36.05-.71.14-1.07.11-.36-.03-.7-.17-1.04-.28-1.63-.51-3.49-.17-4.87.82-.79.56-.98.86-1.81,1.05-1.04.24-1.68.37-2.49,1.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M23.24,14.8c-.14-1.48-.94-2.88-2.1-3.8.13.39.23.8.27,1.21.19,1.97-.78,4.02-2.43,5.12-.51,1.64-1.82,3.01-3.44,3.59-1.61.59-3.5.38-4.94-.55-.31-.2-.66-.44-1.01-.31-.22.08-.36.28-.51.47-.98,1.24-2.7,1.85-4.24,1.5-.48-.11-.93-.31-1.34-.57.35,1.54,1.64,2.82,3.17,3.17,1.54.35,3.26-.26,4.24-1.5.14-.18.29-.39.51-.47.34-.12.7.12,1.01.31,1.45.93,3.33,1.14,4.94.55,1.61-.59,2.92-1.96,3.44-3.59,1.65-1.1,2.62-3.14,2.43-5.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M4.99,12.68c-1.41.06-2.49,1.62-2.21,3s1.74,2.36,3.15,2.27c.47-.03.97-.19,1.24-.57.21-.29.25-.67.27-1.03.03-.62,0-1.25-.11-1.86.95.07,1.91-.56,2.22-1.47.23-.68.25-1.62.94-1.84.39-.12.81.09,1.21.05.54-.05.94-.53,1.21-1.01.26-.47.45-1.05.22-1.53-.32-.68-1.24-.77-1.99-.77-1.12,0-2.23.01-3.35.02-1.66,0-1.61.64-2.12,1.87-.4.96-1.49,1.69-.68,2.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M23.01,23.24c-.51.05-1.06.14-1.45.47s-.54,1.01-.17,1.36c-1.89-.58-4.06-.11-5.54,1.2-.78.69-1.36,1.57-1.84,2.48-.51.95-.85,2.3,0,2.95.18.14.4.23.53.41.3.41-.01.96-.24,1.41-.71,1.41-.54,3.23.43,4.48.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4s1.22-3.91.29-5.66c.97-.05,1.81-.84,2.09-1.76.29-.93.1-1.95-.31-2.83-.49-1.04-1.29-1.93-2.28-2.52-.31-.19-.64-.35-.9-.6-.26-.25-.43-.58-.63-.88-.93-1.43-2.59-2.35-4.28-2.46-.97-.07-1.3.04-2.06-.34-.95-.48-1.53-.79-2.68-.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M33.76,40.96c.83-1.24,1.1-2.82.79-4.27-.14.39-.33.76-.56,1.1-1.11,1.65-3.16,2.61-5.13,2.4-1.44.94-3.32,1.16-4.94.59s-2.94-1.93-3.47-3.57c-.11-.35-.24-.76-.58-.88-.22-.08-.46-.01-.69.04-1.55.34-3.26-.29-4.23-1.54-.3-.39-.52-.83-.67-1.29-.7,1.41-.53,3.22.44,4.46.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M21.49,29.42c-1.13-.85-2.95-.33-3.61.91-.66,1.25-.16,2.93.99,3.75.38.28.87.47,1.32.35.35-.09.62-.35.86-.62.42-.46.79-.97,1.1-1.51.69.66,1.83.78,2.65.28.61-.38,1.22-1.1,1.89-.82.38.16.57.58.9.81.45.31,1.07.19,1.58-.01.5-.2,1.02-.52,1.15-1.04.18-.73-.46-1.38-1.05-1.86-.87-.71-1.73-1.41-2.6-2.12-1.29-1.05-1.65-.53-2.83.1-.92.49-2.23.36-2.36,1.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M29.49,6.49c-.51.05-1.06.14-1.45.47-.39.33-.54,1.01-.17,1.36-1.89-.58-4.06-.11-5.54,1.2-.78.69-1.36,1.57-1.84,2.48-.51.95-.85,2.3,0,2.95.18.14.4.23.53.41.3.41-.01.96-.24,1.41-.71,1.41-.54,3.23.43,4.48.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4,1.11-1.65,1.22-3.91.29-5.66.97-.05,1.81-.84,2.09-1.76.29-.93.1-1.95-.31-2.83-.49-1.04-1.29-1.93-2.28-2.52-.31-.19-.64-.35-.9-.6-.26-.25-.43-.58-.63-.88-.93-1.43-2.59-2.35-4.28-2.46-.97-.07-1.3.04-2.06-.34-.95-.48-1.53-.79-2.68-.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M40.25,24.21c.83-1.24,1.1-2.82.79-4.27-.14.39-.33.76-.56,1.1-1.11,1.65-3.16,2.61-5.13,2.4-1.44.94-3.32,1.16-4.94.59-1.62-.57-2.94-1.93-3.47-3.57-.11-.35-.24-.76-.58-.88-.22-.08-.46-.01-.69.04-1.55.34-3.26-.29-4.23-1.54-.3-.39-.52-.83-.67-1.29-.7,1.41-.53,3.22.44,4.46.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M27.51,10.97c-1.13-.85-2.95-.33-3.61.91s-.16,2.93.99,3.75c.38.28.87.47,1.32.35.35-.09.62-.35.86-.62.42-.46.79-.97,1.1-1.51.69.66,1.83.78,2.65.28.61-.38,1.22-1.1,1.89-.82.38.16.57.58.9.81.45.31,1.07.19,1.58-.01.5-.2,1.02-.52,1.15-1.04.18-.73-.46-1.38-1.05-1.86-.87-.71-1.73-1.41-2.6-2.12-1.29-1.05-1.65-.53-2.83.1-.92.49-2.23.36-2.36,1.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M10.02,19.2c-.58.36-1.14.78-1.49,1.36-.76,1.25-.36,2.85.13,4.23-1.71.59-2.22,3.08-1.13,4.53,1.08,1.45,3.22,1.82,4.93,1.21,1.21,1.21,2.97,1.84,4.67,1.68,1.7-.16,3.31-1.12,4.27-2.54.19-.29.39-.61.71-.74.27-.1.57-.04.86-.03.98.04,1.92-.51,2.5-1.3s.84-1.77.9-2.75c.03-.48.02-.98.16-1.44.1-.34.29-.65.42-.97.53-1.27.26-2.8-.57-3.89-.83-1.09-2.17-1.75-3.54-1.86-.72-1.37-2.18-2.33-3.72-2.43-2.28-.15-3.08,1.19-4.39,2.63-1.09,1.2-3.28,1.43-4.72,2.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M11.21,27.15c-.5-1.38-.9-3-.14-4.25.35-.58.92-1.01,1.5-1.37,1.44-.91,3.64-1.14,4.73-2.35,1.31-1.44,2.11-2.8,4.4-2.64,1.55.11,3.02,1.07,3.74,2.45.59.05,1.17.2,1.71.44-.14-.5-.38-.98-.69-1.39-.83-1.1-2.18-1.76-3.55-1.88-.72-1.38-2.19-2.34-3.74-2.45-2.29-.15-3.09,1.2-4.4,2.64-1.09,1.2-3.29,1.44-4.73,2.35-.58.36-1.14.79-1.5,1.37-.76,1.26-.36,2.87.14,4.25-1.72.59-2.23,3.09-1.14,4.56.49.66,1.19,1.09,1.97,1.32-.12-1.28.49-2.63,1.7-3.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M26.39,18.58c-.14-.18-.29-.35-.46-.51.03.55-.05,1.1-.26,1.61-.14.33-.32.64-.42.97-.14.46-.13.96-.16,1.44-.06.98-.32,1.96-.9,2.75-.58.79-1.52,1.34-2.5,1.3-.29-.01-.59-.07-.86.03-.32.13-.51.45-.71.74-.96,1.42-2.56,2.38-4.27,2.54-1.7.16-3.46-.47-4.67-1.68-1.38.49-3.04.34-4.2-.5-.05.73.12,1.48.56,2.07,1.08,1.45,3.22,1.82,4.93,1.21,1.21,1.21,2.97,1.84,4.67,1.68,1.7-.16,3.31-1.12,4.27-2.54.19-.29.39-.61.71-.74.27-.1.57-.04.86-.03.98.04,1.92-.51,2.5-1.3.58-.79.84-1.77.9-2.75.03-.48.02-.98.16-1.44.1-.34.29-.65.42-.97.53-1.27.26-2.8-.57-3.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M21.36,17.06c-1.29.54-2.5,1.47-3,2.78-.5,1.31-.1,3.01,1.13,3.68-.08.89-.13,1.89.43,2.59.51.62,1.37.82,2.16.9,1.23.12,2.74-.12,3.24-1.26.89.8,2.2,1.11,3.35.79,1.16-.32,2.12-1.25,2.48-2.4.12-.39.18-.81.36-1.18.12-.25.3-.47.43-.71.4-.72.4-1.64-.01-2.36-.41-.71-1.2-1.19-2.02-1.22-.05-.93-.62-1.82-1.45-2.25-1.06-.56-1.96-.08-3.01,0-1.45.12-2.7.03-4.1.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M31.94,19.91c-.25-.44-.66-.8-1.12-1.01-.05.2-.12.4-.23.58-.13.24-.31.46-.43.71-.18.37-.24.79-.36,1.18-.36,1.14-1.32,2.08-2.48,2.4-1.16.32-2.46,0-3.35-.79-.5,1.14-2,1.38-3.24,1.26-.43-.04-.87-.12-1.27-.28-.05.77,0,1.57.47,2.16.51.62,1.37.82,2.16.9,1.23.12,2.74-.12,3.24-1.26.89.8,2.2,1.11,3.35.79,1.16-.32,2.12-1.25,2.48-2.4.12-.39.18-.81.36-1.18.12-.25.3-.47.43-.71.4-.72.4-1.64-.01-2.36Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1132.93,
  y1: -77.12,
  x2: 1509.57,
  y2: 2058.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#e1f5fd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#95dcf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#1cb6ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#00adee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#003c73"
})), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-1",
  x: 5.76,
  y: 73.84,
  width: 1747.68,
  height: 1212.72,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 7.49,
  dy: 7.49
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 17.49
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 871.99,
  cy: 672.6,
  fx: 871.99,
  fy: 672.6,
  r: 700.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d9d9d9"
})), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-2",
  x: 1620.48,
  y: 73.6,
  width: 1002.24,
  height: 318.96,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 7.49,
  dy: 7.49
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-2",
  stdDeviation: 17.49
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-3",
  x: 0,
  y: 1321.12,
  width: 2657.76,
  height: 673.44,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 7.49,
  dy: 7.49
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-3",
  stdDeviation: 17.49
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-3",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 1321.3,
  cy: 1650.2,
  fx: 1321.3,
  fy: 1650.2,
  r: 924.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d9d9d9"
})), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-4",
  x: 1948.56,
  y: 1515.52,
  width: 108.48,
  height: 106.32,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 7.49,
  dy: 7.49
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-4",
  stdDeviation: 17.49
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-4",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 1995.2,
  cy: 1561.08,
  fx: 1995.2,
  fy: 1561.08,
  r: 1.12,
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-5",
  x: 1847.96,
  y: 69.72,
  width: 817.68,
  height: 813.36,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 7.74,
  dy: 7.74
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-5",
  stdDeviation: 18.07
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-5",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 1685.04,
  cy: 296.89,
  fx: 1685.04,
  fy: 296.89,
  r: 359.59,
  gradientTransform: "translate(-116.32 -2.69) scale(1.06 1)",
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-6",
  x: 1203.12,
  y: 297.52,
  width: 726.24,
  height: 598.08,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: -17.49,
  dy: 17.49
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-6",
  stdDeviation: 17.49
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#00adee",
  floodOpacity: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-6",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: 1685.04,
  cy: 296.89,
  fx: 1685.04,
  fy: 296.89,
  r: 359.59,
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 2366.07,
  y1: 1012.34,
  x2: 2853.68,
  y2: 1001.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#c9c9c9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#c9c9c9",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c9c9c9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-6",
  cx: 1685.04,
  cy: 296.89,
  fx: 1685.04,
  fy: 296.89,
  r: 359.59,
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-7",
  cx: 1685.04,
  cy: 296.89,
  fx: 1685.04,
  fy: 296.89,
  r: 359.59,
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-8",
  cx: 1685.04,
  cy: 296.89,
  fx: 1685.04,
  fy: 296.89,
  r: 359.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d9d9d9"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "water"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-30",
  points: "50.4 113.76 2593.52 119.05 2598.8 1866.86 50.4 1870.83 50.4 113.76"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "land"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-19"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M1647.61,307.52l-91.63,25.39-84.11.18c42.68-87.32-21.04-151.93-101.9-85.57l-82.29,84.93h-.45l-194.39,197.56v76.28l30.87,28.58-1.15,91.59-71.3,63.9-291.73-5.32-1.15-.03-1.4,16.71-46.69,381.27-.25,1.53h1.53l-1.66,41.71-72.58-4.97-63.66-3.7-1.4-.13-1.27-.25-1.41-.13-1.4-.13-1.28-.13-1.27-.12-1.28-.13-1.27-.13-1.15-.25-1.28-.13-1.14-.13-1.15-.13-1.15-.25-1.15-.13-1.15-.13-1.02-.25-2.17-.26-2.04-.38-2.04-.38-1.91-.38-1.91-.39-1.79-.38-1.66-.38-1.78-.51-1.66-.39-1.53-.38-1.66-.51-1.53-.51-1.41-.38-1.53-.51-1.4-.51-1.4-.51-1.41-.51-1.27-.51-1.4-.64-1.28-.51-2.68-1.28-2.55-1.14-2.55-1.28-2.68-1.4-1.28-.77-1.4-.64-1.27-.76-1.41-.77-1.4-.76-1.4-.77-1.41-.76-1.53-.77-1.4-.89-1.53-.77-1.53-.89-1.53-.89-3.06-1.79-3.07-1.78-3.18-1.79-3.19-1.91-3.19-1.92-3.32-1.91-3.19-2.04-3.31-2.04-6.51-3.96-3.19-2.04-3.32-2.04-3.18-2.04-3.19-2.04-3.06-2.17-3.19-2.04-3.07-1.91-2.93-2.04-2.93-2.04-1.53-1.03-1.41-1.02-1.4-.89-1.4-1.02-1.28-.89-1.4-1.02-1.28-.9-1.27-1.02-1.28-.89-1.27-.89-1.28-.89-1.15-1.02-1.27-.9-1.15-.89-1.15-.77-1.15-.89-1.02-.89-1.15-.89-1.02-.77-1.02-.89-1.02-.77-1.02-.89-2.04-1.53-1.91-1.66-1.79-1.53-1.78-1.53-1.79-1.41-1.66-1.53-1.66-1.4-1.65-1.4-1.54-1.28-1.65-1.4-1.53-1.28-1.41-1.27-1.53-1.28-1.53-1.15-1.4-1.14-1.53-1.28-1.41-1.02-1.4-1.15-1.53-1.15-1.4-1.02-1.53-1.02-1.53-1.02-1.54-1.02-1.53-.89-1.65-1.02-1.66-.89-1.66-.9-1.66-.89-1.78-.89-1.92-.9-1.91-.89-1.92-.76-2.04-.9-1.02-.38-1.02-.38-1.15-.51-1.14-.39-1.02-.38-1.15-.38-1.28-.38-1.15-.51-1.14-.39-1.28-.38-1.27-.38-1.28-.38-1.28-.39-1.4-.51-1.4-.38-1.41-.38-1.4-.39-1.4-.38-1.53-.51-1.53-.38-1.53-.38-1.53-.39-1.66-.51-1.66-.38-1.66-.38-1.66-.51-1.78-.38-1.79-.39-1.78-.51-1.79-.38-1.91-.38-1.92-.51-1.91-.39-2.04-.51-2.04-.38-2.04-.51-2.17-.51-2.17-.38-2.3-.51-2.17-.51-2.42-.51-2.3-.39-2.42-.51-5.1-1.02-2.68-.51-5.36-1.02-2.93-.63-2.81-.51-2.93-.51-1.53-.26-1.53-.38-1.53-.26-1.66-.25-1.53-.26-1.66-.38-1.53-.26-1.66-.25-1.66-.38-1.78-.26-1.66-.25-1.79-.39-1.66-.25-1.78-.38-1.79-.26-1.78-.38-1.92-.26-1.78-.38-1.92-.26-1.91-.38-1.91-.25-2.04-.39-1.92-.25-2.04-.38-2.04-.39-2.04-.38-2.04-.25-2.04-.39-4.34-.76-2.17-.26-2.17-.38-2.16-.38-2.3-.39-2.3-.38-2.29-.38-2.3-.38-2.42-.39-2.3-.38-2.42-.38-2.43-.38-2.55-.39-2.42-.38-2.55-.38-2.55-.51-2.55-.38-2.68-.39-2.55-.38-2.68-.51-2.81-.38-2.68-.39-2.8-.51-2.68-.38-2.94-.51-2.8-.38-2.94-.51-2.8-.38-3.07-.51-2.93-.39-2.93-.51-3.06-.51-3.07-.38-71.56-8.5-.22-922.78,70.33.29,1571.97-.37-45.53,188.55Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-25",
  points: "2562.46 118.77 2562.46 330.76 1868.48 332.24 1736.56 248.07 1665.66 323.82 1693.14 118.97 1869.21 118.93 2562.46 118.77"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-26"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M2592.53,1598.68l4.95,335.56-2547.08-2.64-5.28-68.7,2.64-496.73,51.52,2.64,26.02,2.84,1.41,1.66,4.08,5.1,1.27,1.66,1.28,1.53,1.15,1.66,1.15,1.66,1.14,1.53,1.15,1.66,1.02,1.53,1.02,1.53,1.02,1.66,1.02,1.53.9,1.53.89,1.53.89,1.53.77,1.4.76,1.53.77,1.53.76,1.41.77,1.53.64,1.4.63,1.4.64,1.41.64,1.53.51,1.4.64,1.28.51,1.4.51,1.4.51,1.41.38,1.27.51,1.41.38,1.27.39,1.28.38,1.4.25,1.28.39,1.27.25,1.28.39,1.27.25,1.15.26,1.28.25,1.27.13,1.15.25,1.27.13,1.15.26,1.15.25,2.42.26,2.17.25,2.3.26,4.34v2.16l.12,2.05v7.78l-.12,1.78v5.23l-.13,1.66v9.18l.13,1.28v1.4l.12,1.28.13,1.27.13,1.28.13,1.15.25,1.27.13,1.15.25,1.02.39,1.15.25,1.02.39,1.02.76,2.04.51,1.02.51.9.64.89.64.89.63.89.64.9.77.76.89.9.89.76.9.77,1.02.76,1.14.77,1.03.76,1.27.77,1.28.64,1.27.76,1.41.64.76.38.77.38.76.39.77.25.76.38.89.39.77.25.89.39.9.38.89.25.89.39,1.02.38.9.25,1.02.39,1.02.25,1.02.38,1.14.26,1.03.38,1.14.38,1.15.26,1.15.25,1.27.39,1.28.25,1.28.39,1.4.25,1.4.26,1.41.25,1.53.38,1.53.26,1.53.25,1.66.26,1.78.13,1.79.25,1.78.26,1.92.25,1.91.13,2.04.25,2.04.13,4.34.26,1.15.12h1.15l1.14.13h1.28l1.15.13h1.27l1.28.13h2.55l1.27.12h6.89l1.41.13h5.99l1.53-.13h8.17l1.65-.12h3.45l1.78-.13h1.79l1.79-.13h1.91l1.79-.13,1.91-.12h1.91l2.04-.13,1.92-.13,2.04-.13h2.04l2.04-.12,2.04-.13,2.17-.13,2.17-.13,2.17-.12,2.16-.13,2.17-.26,2.3-.12,2.29-.13,2.3-.13,2.42-.25,2.3-.13,2.42-.26,2.43-.12,2.55-.26,2.42-.13,2.55-.25,2.56-.26,2.55-.12,2.68-.26,2.67-.25,5.36-.52,2.81-.25,2.8-.26,2.81-.25,2.93-.38,2.81-.26,2.93-.25,2.94-.39,3.06-.25,3.06-.38,3.06-.26,3.06-.38,3.19-.26,9.57-1.14,3.32-.39,3.31-.38,3.32-.38,3.44-.39,3.45-.38,3.44-.38,3.45-.51,3.57-.38,3.57-.39,7.4-1.02,3.7-.38,3.7-.51,3.7-.51,3.82-.51,3.96-.38,3.82-.51,3.96-.51,3.95-.64,4.08-.51,4.09-.51,4.08-.51,4.21-.64,4.08-.51,4.34-.64,4.21-.64,4.33-.51,4.34-.63,4.46-.64,4.47-.64,4.46-.64,4.47-.63,4.59-.64,4.59-.64,4.72-.77,4.72-.63,4.72-.64,4.85-.77,70.79-10.84,1.92.26,2.04.12,1.91.26,1.92.13,1.78.12,1.79.13,1.78.26,1.79.12,1.66.13,1.53.13,1.66.13,1.53.12,1.53.13,1.4.13,1.53.13,1.4.12h1.28l1.28.13,1.4.13,1.15.13h1.27l1.15.12,1.15.13h1.15l1.02.13h1.02l1.02.13h1.02l.89.12h1.02l.77.13h.89l.89.13h.77l1.53.13h1.4l1.28.12h2.42l1.02.13h7.27l.51-.13h1.41l.25.13h.26l.12.13.13.13.13.25v1.15l-.13.38v1.15l.13.64v2.17l.13.51v1.66l.12.63v3.96l.13,1.02v6.25l-.13,4.46v7.91l-.12.77v5.36l-.13.12v.13h.13v.13h.25l.13.13h.51l.25.12h.39l.51.13h.51l.64.13h.63l.9.13.89.12h1.02l.51.13h1.15l.64.13h.76l.64.13h.76l.77.12h1.66l.76.13h1.02l.9.13,1.02.13h1.02l1.02.12h1.15l1.14.13h1.15l1.28.13,1.27.13h1.28l1.4.12,1.41.13h1.4l1.53.13,1.53.13,1.66.12h1.53l1.78.13,1.79.13,1.79.13,1.78.12h1.92l1.91.13,4.08.26,2.17.12,2.17.13,2.29.13,2.3.13,2.3.13,2.42.12,7.65.39,2.68.12,2.68.26,2.81.13,2.8.12,2.81.13,2.93.13,3.06.25,2.94.13,3.19.13,3.06.13,3.19.25,3.19.13,3.31.13,3.19.25,3.32.13,3.44.13,3.32.25,3.44.13,3.58.13,3.44.25,3.57.13,3.57.25,7.15.39,7.27.25,7.4.39,7.52.38,7.53.38,7.52.38,7.66.39,15.18.76,15.3.77,7.66.38,7.65.38,7.53.38,7.52.26,7.53.38,7.27.39,7.4.38,7.14.25,3.57.26,3.58.13,3.44.12,3.44.26,3.45.13,3.44.12,3.32.13,3.31.26,3.32.12,3.19.13,3.19.13,3.19.13,3.19.25,3.06.13,2.93.13,3.06.12,2.94.13,2.8.13,2.81.13,2.81.12,2.68.13,2.67.13,2.56.13,2.55.12h2.55l2.42.13,2.43.13,2.29.13,2.3.12h2.17l2.16.13,2.17.13,2.04.13h2.04l2.05.12,1.91.13h1.91l1.79.13h1.78l1.79.13h1.79l1.65.13,1.66.12h3.06l1.53.13h1.41l1.53.13h1.27l1.41.13h2.55l1.27.12h2.43l1.15.13h2.16l1.02.13h2.81l1.02.13h2.55l1.53.12h4.09l1.14.13h13.01l.51-.13h1.15l.64-.12h.77l.76-.13.77-.13,1.02-.13.89-.12,1.15-.13,1.15-.26,1.27-.12.77-.13.63-.13,1.54-.26.76-.12.89-.13.77-.13.89-.13,1.02-.12.9-.13,1.02-.13,1.02-.25,1.14-.13,1.02-.13,1.15-.25,1.15-.13,1.28-.26,1.27-.25,1.28-.13,1.4-.25,1.4-.26,1.41-.25,1.53-.26,1.4-.25,1.66-.26,1.53-.25,1.66-.26,1.78-.25,1.79-.39,1.79-.25,1.91-.26,1.91-.38,1.92-.26,2.04-.38,2.04-.38,2.17-.38,2.16-.39,4.6-.76,2.29-.38,2.43-.39,2.55-.38,2.42-.51,2.68-.38,2.68-.39,2.68-.51,2.8-.51,2.81-.38,2.81-.51,2.93-.51,2.93-.51,3.07-.51,3.06-.51,3.19-.51,3.06-.51,3.19-.64,3.31-.51,3.19-.51,3.32-.64,3.44-.51,3.32-.63,3.44-.51,3.45-.64,3.44-.51,7.02-1.28,7.14-1.15,7.27-1.27,7.27-1.15,7.4-1.28,7.4-1.27,7.53-1.28,15.05-2.55,30.1-5.1,7.53-1.28,7.4-1.27,7.39-1.15,7.28-1.27,7.14-1.28,7.14-1.15,3.45-.64,3.57-.51,3.44-.63,3.32-.51,3.44-.64,3.32-.51,3.32-.64,3.31-.51,3.32-.51,3.19-.64,3.06-.51,3.19-.51,3.06-.51,3.06-.51,2.93-.51,2.94-.51,2.93-.51,2.81-.38,2.81-.51,2.67-.51,2.68-.39,2.55-.51,2.56-.38,2.55-.38,2.42-.38,2.42-.39,2.3-.51,2.3-.25,2.16-.39,2.17-.38,2.04-.38,2.04-.38,2.05-.26,1.91-.38,1.91-.26,1.92-.38,1.78-.25,1.66-.26,1.79-.25,1.65-.39,1.53-.25,1.54-.26,1.53-.25,1.53-.13,1.4-.25,1.4-.26,1.28-.26,1.27-.12,1.28-.26,1.28-.13,1.14-.25,2.3-.26,1.02-.25,2.04-.26.89-.12,1.02-.13.9-.13.76-.13.9-.12.76-.13.77-.13.76-.13h.64l.64-.12,1.27-.13,1.15-.13,1.02-.13,1.02-.12h.89l.77-.13h2.81l.38.13h.38l.26.12h.25l.51.26.39.25.38.26.64.64.63.76.64.89.51.9.38.89.9,1.91.89,1.92.38.89.39.89.51.77.51.76.51.64.51.64.51.64.63.51.51.51.64.51.64.38.77.38.76.51.38.13.51.26.51.25.51.26.51.25.64.38.64.39.64.38.76.38.9.39.89.51.89.63,1.02.64,1.15.64,1.15.76,1.27.77.77.38.64.51,1.4.9,1.53,1.02,1.66,1.02,1.66,1.14,1.78,1.02,1.79,1.28,1.79,1.15,1.78,1.15,1.91,1.27,3.83,2.43,3.83,2.42,1.91,1.15,1.91,1.15,1.92,1.14,1.78,1.02,1.79,1.02,1.79.9,1.78.89,1.53.77,1.66.76,1.53.64,1.53.64,1.4.51,1.54.51,1.4.51,2.93,1.02,1.53.38,1.53.38,1.53.51,1.54.39,1.78.51,1.66.51,1.79.51,1.91.51,2.04.63,1.02.26,1.02.38,1.02.26,2.3.76,1.15.39,1.27.51,1.28.38,1.14.38,1.41.51,1.27.51,1.41.38,1.4.51,1.4.52,1.41.51,1.53.51,1.53.51,3.06,1.02,1.53.63,1.66.51,1.66.51,3.44,1.15,3.44,1.02,3.58,1.02,3.82,1.15,3.7.89,3.96,1.02,4.08.9,2.04.51,2.04.38,2.17.51,2.04.38,2.17.39,2.17.38,2.17.38,2.29.26,2.17.38,2.3.25,2.29.26,2.3.25,4.72.39,4.72.38,4.72.26,4.84.12,4.85.26h14.42l4.59-.13,4.72-.13,4.46-.12,4.47-.13,2.17-.13,2.16-.13,2.17-.12,2.04-.13,2.04-.13,2.05-.13,2.04-.13,1.91-.12,1.79-.13,1.91-.13,1.78-.13,1.66-.12,3.32-.26,1.53-.13,1.53-.12,1.4-.13,1.41-.13,1.4-.13,1.28-.12,1.14-.13,1.28-.13,1.15-.13,1.02-.12,1.02-.13,1.02-.13,1.02-.13.89-.12.77-.13.89-.13.77-.13.76-.12.77-.13.63-.13.77-.13.64-.12,1.15-.39,1.14-.25,1.02-.38.9-.52.89-.38.77-.51.89-.51.76-.51.77-.64.76-.63.77-.77.77-.76.76-.77.89-.89.9-.9.76-.89,1.02-.89.89-1.02,1.03-1.02,1.02-.9,1.02-1.02,1.14-1.14,1.15-1.02,1.15-1.03,1.28-1.02,1.27-1.02,1.28-1.02,1.53-.89,1.4-1.02,1.53-1.02,1.66-.89,1.66-.9,1.66-.76,1.78-.89,1.92-.77,1.78-.89,1.92-.64,3.82-1.53,3.96-1.4,3.95-1.28,3.83-1.4,1.91-.64,1.79-.64,1.91-.51,1.66-.64,1.78-.63,1.66-.64,1.53-.64,1.53-.64,1.53-.64,1.41-.51,1.27-.63,1.28-.64,1.15-.51,1.14-.51,1.03-.51,1.02-.39.89-.38.89-.38.77-.38.63-.26.64-.13.64-.12.51-.13h.38l.39.13.38.12.13.26.25.38v.38l.13.51v.52l-.13.63-.13.77-.12.76-.13.77-.26.76-.25.9-.26,1.02-.25.89-.26,1.02-.63,2.04-.64,2.17-.51,2.17-1.02,4.34-.26,2.04-.25,2.04-.26,1.91v1.02l-.13.89v.9l-.12.76v1.66l-.13.64v3.7l.13.25.12.26.13.25.26.13.25.26.26.25.38.13.51.25.64.26.64.25.76.26.51.13.38.12.51.26.51.13.51.12.64.13.64.26.64.13.64.12.76.26.77.13.76.25.89.13.9.25.89.26.89.25,1.02.13,1.15.26,1.02.25,1.15.26,1.15.25,1.27.26,1.28.38,1.28.25,1.4.26,1.4.38,1.53.26,1.53.38,1.66.26,1.53.38,1.79.38,1.66.38,1.91.39,1.79.38,1.91.38,2.04.38,2.04.51,2.17.39,2.17.38,2.17.51,2.42.51,2.3.51,2.42.51,5.1,1.02,2.68.51,2.68.64,2.81.51,2.8.64,2.94.51,3.06.64c1.02.26,2.04.52,3.06.77,186.95,46.87,373.66,7.47,543.26,30.47,7.51,1.02,45.1,5.47,52.54,6.74Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-16"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1996.73,1561.33v.14c-1.02-.25-2.04-.51-3.06-.77l3.06.63Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M2603.43,116.41v704.47c-121-.37-243.1-20.92-365.92-54.36l-1.89-.19-1.76-.19-1.76-.19-1.76-.17-1.62-.19-1.62-.19-1.62-.19-1.62-.17-1.49-.19-1.5-.19h-1.49l-1.49-.19-1.36-.17-1.49-.19-1.36-.19-1.35-.19-1.22-.17h-1.36l-1.22-.19-1.21-.19-1.22-.19-1.08-.17h-1.22l-1.08-.19-1.08-.19h-1.08l-1.08-.19-1.08-.17-2.04-.19-1.89-.19-1.9-.19-1.89-.17-1.76-.19-1.76-.19-1.62-.19-1.76-.19h-1.62l-1.49-.17h-1.62l-1.62-.19h-9.08l-2.84.19-2.98.17-2.84.19-2.83.19-5.69.55-5.83.56-2.84.36-2.97.37-2.98.36-2.97.19-3.12.36-3.11.19-3.12.37-3.25.17-6.36.56-3.25.17-3.12.19-3.25.37-3.11.17-2.98.19-1.49.19h-1.5l-1.49.19-1.35.17-1.5.19h-1.35l-1.36.19-1.35.19-1.22.17-1.36.19-1.22.19-1.08.19-1.21.17-1.08.19-1.09.19-1.08.19-1.08.17-1.89.37-.96.19-1.89.55-1.76.37-1.76.55-3.39.92-1.75.36-1.63.37-1.89.36-1.76.55-.94.19h-1.08l-.96.19-1.08.19-.94.17-1.08.19-1.22.19h-1.08l-1.22.19-1.21.17h-1.36l-1.22.19h-2.71l-1.35.19h-4.2l-2.98.19h-5.95l-2.97-.19h-2.98l-2.98-.19h-2.97l-2.84-.19-2.84-.17h-1.49l-1.36-.19h-1.36l-1.21-.19-1.36-.19h-1.22l-1.21-.17h-1.22l-1.08-.19-1.22-.19h-1.08l-1.08-.19-1.08-.17-1.08-.19-2.04-.19-2.03-.19-1.9-.36-1.75-.19-1.9-.36-1.76-.19-1.76-.37-3.25-.36-3.39-.55-3.39-.37-1.75-.19h-1.62l-1.76-.17h-1.76l-1.62-.19h-1.76l-1.76.19h-3.52l-1.75.17-1.62.19-1.76.19-1.76.36-1.76.37-1.62.36-1.76.37-1.76.55-1.62.55-.94.19-.94.37-.96.36-.94.37-.94.36-1.08.37-1.08.36-1.08.37-1.22.36-1.08.55-1.36.37-1.22.55-1.49.56-1.35.55-1.5.55-1.62.55-1.62.56-.81.17-.96.37-.94.36-.82.19-.94.37-.94.36-1.08.37-.94.36-1.08.19-.96.36-1.08.37-1.08.36-1.22.37-1.08.37-1.22.36-1.21.37-1.22.36-1.22.55-1.35.37-1.22.36-1.36.37-1.35.36V119.77c0-6.98,343.08-.92,343.08-.92l365.92-2.43Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1894.15,821.86h-14.29v3.57h-606.67l.51-292.13,169.02-172.31,28.83-28.32h422.6v489.19ZM1722.82,518.95c-4.09-6.79-10.88-11.51-18.67-12.96l-1.12-.17c-7.44-.35-14.83,1.32-21.39,4.83l-.16.08,6.04,5.24-18.02,18.37.44.38,4.69,4.09.14.12-10.84,11.1-3.19-2.81-.26.64-.26.77-.26.64-.38.64-.26.64-.38.64-.38.64-.38.64-.38.51-.38.64-.51.64-.51.64-.51.64-.51.77-1.02,1.28-1.15,1.28-1.15,1.28-.64.51-.51.64-.64.51-.51.51-.64.51-.51.51-.64.38-.51.51-.51.38-.51.38-1.15.64-1.02.64-1.15.64-1.15.51-1.15.64-2.3,1.15-2.3,1.15-1.15.64-1.15.64-1.02.51-1.02.64-.89.64-1.02.77-1.02.64-.64.38-.51.51-.51.38-.64.38-.64.51-.64.51-1.15,1.02-1.28,1.02-1.28,1.15-1.15,1.15-.64.51-.51.64-.51.51-.51.51-.51.64-.51.51-.38.51-.38.64-.77,1.02-.77,1.02-.64,1.02-.64,1.02-.64,1.02-.51,1.02-1.15,1.91-.64,1.02-.51,1.02-.51,1.15-.64,1.15-.51,1.28-.51,1.28-.51,1.28-.51,1.4-.38,1.4-.51,1.4-.13.77-.13.77-.13.77-.13.89-.13.89-.13.51v.51l-.13.51v1.85s14.03.19,14.03.19l-.13,14.67-13.34-.18.2.69.26.77.26.89.26.64.26.77.26.64.13.64.26.51.13.51.26.51.13.51.26.38.13.38.13.38.13.38.26.26.13.38.26.51.26.51.26.38.26.51.26.38.38.77.51.64.26.38.38.38.26.51.38.38.26.51.38.38.38.51.51.51.77,1.02,1.02,1.02.89,1.02.89,1.02.51.38.51.51.51.38.51.38.64.51.64.38.64.38.77.38.77.51.77.38.89.51.89.38.89.38.89.51,1.91.77.89.38.89.26.89.38.89.26.77.26.77.26.77.26.77.13.64.26.64.13.77.13h.64l1.28.26h1.4l1.4.13h2.17l.77-.13h.77l.89-.13h.77l.77-.13,1.66-.26,1.66-.26.89-.13.77-.26.77-.13.77-.13.77-.26.64-.13.64-.26.64-.26.64-.13.51-.26,1.15-.51,1.15-.51,1.02-.51,1.28-.51,1.15-.64,1.28-.77.64-.38.64-.38.51-.38.64-.38.51-.51.51-.51.64-.51.38-.51,1.02-1.02.89-1.15.38-.51.38-.51.51-.38.38-.51.38-.38.38-.38.26-.38.38-.38.38-.38.38-.26.64-.64.64-.51.64-.51.64-.38.64-.38.64-.26.64-.38.64-.26.77-.26.64-.13.77-.26.77-.13h.77l.89-.13.89-.13h.89l.89-.13.89-.13,1.02-.13,1.02-.26.51-.13.51-.13.64-.13.51-.26.64-.26.51-.13.64-.26.64-.26,1.28-.64,1.28-.64,1.28-.64,1.28-.64,1.15-.64,1.15-.64,1.02-.64,1.15-.64.89-.77.51-.38.51-.38.51-.38.51-.51.38-.51.51-.38,1.02-1.15.89-1.02,1.91-2.3.89-1.15.89-1.15.89-1.28.38-.64.51-.64.38-.77.38-.64.26-.77.38-.77.26-.77.38-.77.26-.77.26-.77.26-.89.26-.77.26-.77.13-.89.38-1.66.26-1.53.13-1.66.13-1.66.13-1.66v-4.21l-.13-.89v-1.02l-.13-1.02-.13-1.02-.13-1.02-.13-1.15-.26-1.15-.26-1.28-.26-1.28-.26-1.4-.38-1.4-.38-1.4-.38-1.4-.38-1.4-.38-1.4-.51-1.4-.38-1.4h-.05c-5.18-.24-9.51-4-10.47-9.09l.1-.07c-1.08-4.78-.07-9.8,2.79-13.78l-.09.06c2.51-3.75,5.84-6.89,9.74-9.16l.07.08c1.87-1.2,3.92-2.07,6.05-2.58l.04-.12c2.36-7.57,1.37-15.78-2.72-22.57Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1650.76,538.34l-8.39,8.26-10.08-9.19-1.53,1.53-23.22-21.94-7.65,7.91,15.95,13.91,1.14-1.15,18.76,17.09-7.15,6.12,3.45,4.09-13.78,11.86-7.02-8.04-8.03,6.89,7.52,8.55-10.58,10.71-2.56-2.29-6.76,6.76-7.9-7.53-1.66,1.66-24.37-23.22-4.21,4.21,20.03,19.01.64.51.64.38.51.38.63.39.51.38.39.38.51.39.38.25.38.38.39.26.38.25.38.26.26.25.38.26.25.13.26.25.25.26.13.12.38.39.39.25.25.38.51.51.51.39.77.89.25.51.39.38.38.51.25.39.26.38.25.51.26.38.25.38.26.77.38.77.13.38.13.51.25.51.26.51.51,1.02.38,1.02.26.51.25.51.26.38.12.39.26.38.13.25.76,1.02.38.64.39.51.51.51.25.26.26.25.25.26.26.25.38.26.38.25.77.51.76.39.39.12.38.13h.25l.26.13h.64l.38.13h4.68l.04-4.72,4.59.06v-1.85l.13-.51v-.51l.13-.51.12-.89.13-.9.13-.76.13-.77.12-.76.51-1.41.39-1.4.51-1.4.51-1.28.51-1.27.51-1.28.64-1.15.51-1.14.51-1.03.63-1.02,1.15-1.91.51-1.02.64-1.02.64-1.02.64-1.02.76-1.02.77-1.02.38-.64.38-.51.51-.51.51-.64.51-.51.51-.51.51-.64.64-.51,1.15-1.14,1.27-1.15,1.28-1.02,1.15-1.02.64-.51.63-.51.64-.39.51-.38.51-.51.64-.38,1.02-.64,1.02-.77.89-.63,1.02-.64,1.02-.51,1.15-.64,1.15-.64,2.3-1.14,2.29-1.15,1.15-.64,1.15-.51,1.15-.64,1.02-.64,1.15-.63.51-.39.51-.38.51-.51.63-.38.51-.51.64-.51.51-.51.64-.51.51-.64.64-.51,1.15-1.28,1.14-1.27,1.02-1.28.51-.76.51-.64.52-.64.51-.64.38-.63.38-.52.38-.63.39-.64.38-.64.25-.64.39-.63.25-.64.26-.77.25-.64-10.23-8.89ZM1689.33,472.34l-.02.02-3.83,4.21,4.98,4.08-13.4,14.54,4.21,4.08-6.12,5.74,6.59,5.73.17-.09c6.56-3.51,13.95-5.18,21.39-4.83l1.12.17c7.79,1.46,14.59,6.18,18.67,12.97.21.35.42.71.61,1.06l.18-.08.25-.26.13-.25.26-.13.12-.13.13-.13.26-.38.12-.25.13-.26.13-.25.13-.26.12-.51v-.51l.13-.51v-.38l.13-.51v-.26l.13-.13.12-.25.13-.38.13-.26.26-.38.12-.38.26-.13.13-.26.12-.25.51-.51.26-.38.25-.26.26-.38.38-.38.38-.52.39-.38.38-.51.51-.64.59-.59-41.9-35.65ZM1693.9,637.8l-.64.13-.51.13-.51.12-1.02.26-1.02.13-.89.12-.89.13h-.9l-.89.13-.89.13h-.77l-.76.13-.77.25-.64.13-.76.25-.64.26-.64.38-.63.26-1.28.76-.64.51-.64.51-.63.64-.39.25-.38.39-.38.38-.26.38-.38.39-.38.38-.38.51-.51.38-.39.51-.38.51-.89,1.15-1.02,1.02-.39.51-.63.51-1.02,1.02-.64.38-.51.39-.64.38-.64.38-1.27.77-1.15.63-1.28.51-1.02.52-1.15.51-1.04.46.02.05.26.38.38.25.38.39.26.25.25.26.26.25.25.13.13.25.26.13.13.13.25.13.13.12.25.13.26.13.13.13.25.12.26.13.38.26h.13l.25.12.26.13.25.13.38.13h.39l.38.13.38.12,1.02.26h.51l.51.13h.64l.51.12h3.45l.51-.12h.51l1.02-.26.38-.13.51-.12.76-.26.77-.26.64-.38.76-.38.39-.26.25-.25.38-.26.39-.25.63-.64.64-.76.64-.77.64-.76.51-.77.51-.89.25-.39.13-.51.26-.38.12-.38.13-.38.13-.39.13-.76.12-.77.13-.64.13-.63.13-.51.12-.51.13-.26.13-.25.25-.26.13-.38.51-.51.51-.64.51-.51.26-.38.25-.26.13-.13.26-.25.51-.38.38-.39.38-.38.38-.25.51-.39.39-.25.51-.26.38-.25.38-.13.26-.25.38-.13.13-.13.12-.13.13-.25v-.26l.13-.12v-.64l.13-.26v-.76l.13-.39v-.06l-.39.19ZM1661.25,659.23v-.13l-.13-.12-.26-.26-.12-.13-.13-.12-.26-.13-.12-.26-.39-.25-.25-.26-.13-.25-.25-.13-.26-.25-.13-.13-.03-.04-.22.04-.64.25-.64.26-.64.13-.76.25-.77.13-.76.13-.77.25-.89.13-1.66.25-1.66.26-.76.13h-.77l-.89.12h-.76l-.77.13h-2.17l-1.4-.13h-1.41l-1.27-.25h-.64l-.76-.13-.64-.13-.64-.25-.76-.13-.77-.25-.77-.26-.76-.25-.89-.26-.9-.38-.89-.26-.89-.38-1.92-.76-.89-.52-1.78-.76-.9-.51-.76-.38-.77-.51-.76-.39-.64-.38-.64-.38-.64-.51-.51-.38-.51-.39-.51-.51-.51-.38-.89-1.02-.89-1.02-1.02-1.02-.77-1.02-.51-.51-.38-.51-.39-.39-.25-.51-.38-.38-.26-.51-.38-.38-.26-.38-.51-.64-.38-.77-.25-.38-.26-.51-.25-.38-.26-.51-.25-.51-.13-.39-.26-.25-.12-.38-.13-.39-.13-.38-.25-.38-.13-.51-.26-.51-.13-.51-.25-.51-.13-.64-.25-.64-.26-.76-.25-.64-.26-.89-.25-.77-.2-.69-5.29-.07.04-4.07-.04-.02h-.76l-.77.13h-1.79l-.51.13h-.76l-.38.13h-.26l-.38.12h-.26l-.12.13h-.26l-.38.13-.38.25-.26.13-.25.26-.26.12-.25.26-.26.25-.13.26-.25.25-.26.26-.13.25-.12.39-.13.25-.13.39-.13.38-.12.38v2.04l.12.64.26.76v.39l.13.25.25.39.13.51.25.51.13.25.13.26.13.25.25.38.26.64.51.64.38.76.51.77.51.77.51.76.51.77.51.76.51.64.64.76.64.77.38.38.38.39.39.38.38.51.38.38.51.38,1.53,1.53.51.51.64.51.64.52.51.51.64.63,1.4,1.02,1.4,1.15,1.41,1.02,1.53,1.15,1.4.89,1.53,1.02,1.53.9,1.53.76.77.51.76.38.64.26.77.38.63.39.64.25.64.26.64.38.63.25.64.26.51.13.64.25.51.13.51.25,1.02.26.89.25,1.02.26.9.25.76.13.9.26.89.12h.76l.9.13.89.13h.89l1.02.13h5.23l1.15-.13,1.15-.13,1.27-.13,1.15-.25,1.28-.13,1.15-.25,1.14-.26,1.28-.38,1.15-.26,2.04-.76,1.02-.26,1.02-.38.38-.13.39-.25.76-.26.38-.12.39-.13.25-.13.26-.13.25-.13.26-.12.12-.13h.26l.13-.13h.12l.13-.13.13-.12h.13v-.13h.12v-.13h-.12ZM1776.21,511.77l-3.28.06-34.13.07.07-.13c-1.05,0-2.09-.2-3.06-.58l-.07.07-.89.9-.77.89-.38.51-.38.38-.38.38-.26.39-.38.38-.26.38-.25.39-.26.38-.13.38-.25.38-.13.39-.13.25-.12.38-.13.39-.13.38v1.78l.13.77.13.77.25.76.26.89.51,1.66.25.77.26.89.25.89.13.77v.89l.13.38v2.68l-.13.64v1.4l-.13.64v1.53l-.25,1.53v.64l-.13.77-.13.63-.12.51h.01c2.31.04,4.48.77,6.29,2.01l.33-.22.38-.38.64-.51.64-.64.63-.38.64-.39.51-.38.64-.25.51-.26.51-.25.51-.26.51-.13.51-.12.51-.13h.51l.38-.13h.39l.38-.13h.25l.64-.12h2.17l.26-.13h.51l.38-.13.25-.13.39-.12.76-.26.39-.25.51-.26.38-.26.51-.38.13-.11c-.58-1.45-.9-3.03-.9-4.67,0-5.95,4.18-11.09,10.01-12.3l7.78.11c1.84.05,3.57-.91,4.49-2.51.93-1.59.91-3.57-.05-5.14ZM1496.68,356.81l-4.12-3.64-134.01,136.41,4.34,3.82-1.15,1.15,2.17,1.92-1.02.89-2.05-1.79-7.9,7.91,11.99,10.33,12.75-12.75,12.38,10.71.02-.03c-1.65-5.54-1.33-11.47.87-16.8l-16.2-14.04,3.95-3.95.39.25,17.22-17.34,1.4,1.4,15.56-15.69-1.91-1.91,1.53-1.53,1.91,1.91,15.31-15.44-1.79-1.91,1.53-1.53,1.79,1.91,15.43-15.56-1.91-1.78,1.53-1.54,1.92,1.92,10.46-10.59-2.56-2.42,40.17-40.29ZM1610.22,405.52v-.11c-5.02-4.23-12.44-3.88-17.05.79l-.04.08-170.93,173.48.11-.1c-3.1,3.14-4.83,7.37-4.83,11.77l-.13.07v80.74l.13-.06c0,9.26,7.51,16.77,16.77,16.77l-.06.13h211.11l.13-13.01v-.89l-.13-.39v-.38l-.13-.25-.12-.26-.13-.13-.13-.25-.25-.51-.51-.51-.39-.38-.51-.51-.38-.39-.25-.12-.13-.26-.26-.13-.12-.13-.26-.12-.25-.13h-.39l-.25-.13h-2.04l-.51-.13h-2.17l-.77-.12-.89-.13-1.02-.13-.89-.13-1.02-.12-1.15-.26-1.15-.25-1.15-.26-1.27-.25-1.28-.39-1.28-.38-1.27-.38-1.4-.38-1.28-.51-1.28-.39-.51-.25-.63-.26-1.02-.51-1.02-.38-1.02-.51-1.03-.51-1.02-.51-.89-.51-.51-.38-.64-.26-1.02-.64-1.14-.76-1.15-.77-1.15-.76-1.15-.9-1.15-.76-1.15-.89-1.02-.9-2.04-1.78-.89-.9-1.02-1.02-.89-.89-1.02-1.02-.9-1.15-.89-1.02-.89-1.15-.9-1.14-.76-1.02-.89-1.15-.64-1.02-1.28-2.04-.63-1.02-.51-.9-.39-.89-.51-.89-.38-.77-.38-.76-.26-.77-.25-.38-.13-.51-.13-.39-.25-.51-.13-.51-.13-.63-.13-.64-.25-.64-.13-.76-.25-.64-.26-1.53-.38-1.66-.38-1.53-.13-.77-.13-.64-.13-.76-.25-.64-.13-.51-.13-.64-.12-.51-.13-.38-.13-.51-.13-.38-.13-.38-.12-.26-.13-.38-.13-.26-.25-.51-.13-.51-.26-.51-.25-.38-.51-.89-.26-.39-.25-.51-.38-.38-.26-.51-.76-1.15-.39-.51-.38-.51-.38-.38-.39-.38-.38-.39-.38-.25-.51-.26-.26-.12-.25-.13-.26-.13-.25-.13-.38-.12-.39-.13v.13l.02,5.23h.01l.23,52.04-51.54.13v4.08l36.87-.13v9.95l-43.5.13-.25-76.03-14.55-13.14,6.38-6.5-1.15-1.02,2.43-2.42,1.02,1.02,5.1-5.11-1.15-1.02,4.47-4.59,3.82,3.57,1.41-1.4,11.48,10.33,105.74-107.28-4.2-4.08,9.31-9.31-1.53-1.4,9.05-9.06,3.19,3.19,3.06-3.06,8.68,7.52,2.8-3.31-60.08-50.64ZM1573.1,613.06l.26,52.04-.24-52.04h-.02ZM1848.89,522.62v99.75h3.57v31.5h-6.38v24.88h-33.93v1.02h-22.58v-4.08h-57.65v-6.13h-2.81v-3.44h2.81v-16.58h11.73v-14.29h39.42v-3.06h-47.84v-6.12h-6.12v-2.94h3.19v-17.09h15.05v-9.31h-15.05v-14.03h3.7v-11.87h20.66v8.8h6.25v-8.8h20.16v-4.46h-39.55v-9.06h21.43v5.61h2.68v-11.35h-7.91v-2.04h4.21v-5.48l.06-.14c-2.77-.58-5.16-2.03-6.91-4.05-.01,0-.16.1-.16.1l-.64.39-.64.38-.51.25-.51.26-.38.25-.51.13-.38.13-.39.13-.25.12-.39.13-.63.13h-.64l-.77.13h-1.53l-.89.13h-.51l-.38.12-1.02.26h-.13l-.38.13-.26.12-.25.26-.39.13-.25.25-.38.26-.51.25-.51.38-.52.39-.51.51-.38.25-.21.21c.95,1.38,1.6,2.99,1.87,4.75v.02s-4.62.73-4.62.74c.51,9.89-5.87,18.82-15.39,21.53l-.02.05.13.64.13.63.13.52.25.63.13.51.13.51.12.39.13.51.13.38.13.51.25.76.26.64.12.77.26.64.13.51.38,1.27.25,1.28.39,1.27.25,1.28.26,1.27.13,1.41.12,1.4.13,1.4.13,1.41.13,1.53.12,1.53v6.89l-.12.76v.64l-.13.64-.13,1.27-.13,1.15-.12.64-.13.64-.13.63-.25.64-.13.77-.26.76-.25.77-.26.89-.38.89-.26.9-.38.89-.38,1.02-.51.89-.38,1.02-.51,1.02-.64.9-.51,1.02-.64,1.02-.64.89-.76,1.02-.64,1.02-.77.89-.89.9-.76,1.02-.77.89-.89.89-.9.9-1.78,1.78-1.02.9-.89.76-.9.77-.89.76-.89.77-1.02.76-.9.64-.89.64-.77.51-.89.64-.76.51-.77.38-.76.51-.77.38-.64.38-.64.39-.51.25-.51.26-.51.25-.51.26-.25.25-.38.13-.26.13-.25.25-.26.13-.25.13h-.13l-.26.25-.25.13-.51.26-.26.12-.25.26-.26.13-.25.25-.26.13-.13.25-.12.13-.26.26-.13.25-.12.26-.26.25-.13.38-.12.39-.13.38-.26.89-.25.9-.26.89v.38l-.12.38v.39l-.13.25v.38l-.13.26-.13.51-.12.25v.26l-.13.26-.26.25-.12.38-.26.39-.25.38-.26.38-.38.51-.26.51-.76.89-.77,1.02-.38.39-.38.51-.39.38-.38.38-.38.39-.38.25-.39.38-.38.26-.38.25-.39.26-.38.25-.38.26-.51.13-.51.25-.89.38-1.02.39-1.03.38-1.02.26-.51.12-.51.13-.89.26-.76.12-.9.13-.76.13h-2.94l-.76-.13-.64-.13-.76-.12-1.92-.39-.64-.12-1.02-.26h-.89l-.38-.13-.38.13h-.77l-.38.13-.39.13-.25.12-.38.13-.39.26-.63.63-.39.39-.25.38-.38.51-.13.25-.13.26-.13.25v.39l-.12.25v.77l.12.38-.25,18.24h192.87l.06-.13c7.72,0,13.97-6.25,13.97-13.96v-152.37h-15.56ZM1413.02,540.09l-2.94,3.32-10.97-9.31-5.48,5.86-42.48-.12-17.86-15.57,17.86-18.24-4.59-4.21-40.95,41.84v6.64h-15.56v126.54l11.61-.26v12.5h74.49l.07-.13c9.26,0,16.77-7.51,16.77-16.77v-121.37h18.62l6.25-6.38-4.84-4.34ZM1850.48,711.66h-180.81v95.29h194.78v-81.32c0-7.72-6.25-13.97-13.97-13.97ZM1305.1,711.66v3.83h-9.44l-5.61,5.35v77.69l.13-.07c0,4.62,3.74,8.36,8.35,8.36l-.06.13h325.27v-95.29h-318.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1864.45,332.68v84.13c0,2.19-.87,4.3-2.41,5.87l-63.27,64.03c-1.57,1.59-3.71,2.49-5.95,2.49l-.06.12h-44.26l.06-.12c-1.98,0-3.89-.71-5.4-1.98l-.02.06-182.54-154.6-40.59.31-48.19-.31,48.19-40.59,173.8-173.8h170.16v214.39h.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1866.82,332.68v84.13c0,2.19-.87,4.3-2.41,5.87l-63.27,64.03c-1.57,1.59-3.71,2.49-5.95,2.49l-.06.12h-44.26l.06-.12c-1.98,0-3.89-.71-5.4-1.98l-.02.06-182.54-154.6-40.59.31-48.19-.31,48.19-40.59,173.8-173.8h170.16v214.39h.48Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-14",
  points: "758.38 785.04 729.94 784.5 732.23 752.99 706.34 709.75"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-5",
  points: "706.34 709.75 691.92 718.42 691.03 720.97 690.14 723.65 689.37 726.2 688.48 728.75 687.71 731.3 686.95 733.85 686.18 736.28 685.54 738.7 684.78 741.13 684.14 743.55 683.38 745.84 682.74 748.14 682.1 750.44 681.46 752.73 680.95 755.03 680.31 757.33 679.8 759.49 679.17 761.66 678.66 763.83 678.15 766 677.64 768.17 677.13 770.21 676.62 772.38 676.23 774.42 675.72 776.46 675.34 778.5 674.83 780.54 674.45 782.58 673.55 786.54 672.79 790.49 672.15 794.45 671.39 798.27 670.75 802.1 670.11 805.93 669.47 809.62 668.96 813.45 668.32 817.15 667.81 820.85 667.3 824.55 666.79 828.25 666.28 832.08 665.9 835.77 665.39 839.47 665.01 843.3 664.62 847 664.11 850.83 663.73 854.65 663.35 858.48 663.09 862.43 662.71 866.39 662.33 870.34 662.07 874.42 661.69 878.51 661.44 882.72 661.05 886.93 660.8 891.26 660.67 893.43 660.54 895.6 660.29 897.77 660.16 900.06 660.03 902.36 659.91 904.53 659.78 906.83 659.65 909.25 659.52 911.54 659.39 913.84 659.27 916.26 659.01 918.69 658.88 921.11 658.76 923.54 658.63 925.96 658.5 928.51 658.37 930.93 658.25 933.48 658.12 936.04 657.99 938.59 657.74 941.27 657.61 943.94 657.48 946.5 657.35 949.17 657.23 951.85 656.97 954.66 656.84 957.34 656.72 960.14 656.59 962.95 656.33 965.76 656.21 968.69 656.08 971.5 655.82 974.43 655.7 977.37 655.44 980.43 655.31 983.36 655.06 986.42 654.93 989.48 654.68 992.55 654.55 995.61 654.29 998.8 654.04 1001.98 653.91 1005.17 653.65 1008.36 653.4 1011.55 653.14 1014.87 653.02 1018.18 652.76 1021.5 652.51 1024.95 652.25 1028.26 651.74 1035.15 651.23 1041.91 650.72 1048.93 650.21 1055.81 649.57 1062.83 648.55 1076.86 647.91 1083.75 647.4 1090.77 647.15 1094.72 702.25 1097.65 703.79 1062.06 696.13 1062.06 696.13 1077.88 662.33 1075.84 662.97 1067.68 663.6 1059.39 664.24 1051.22 664.88 1043.06 665.52 1034.89 665.77 1030.81 666.16 1026.86 666.41 1022.78 666.67 1018.82 667.05 1014.87 667.3 1010.91 667.56 1007.09 667.81 1003.26 668.07 999.43 668.32 995.61 668.58 991.91 668.83 988.21 669.09 984.51 669.34 980.94 669.6 977.37 669.73 973.79 669.98 970.22 670.24 966.78 670.37 963.33 670.62 960.02 670.75 956.7 671 953.38 671.13 950.07 671.39 946.88 671.51 943.56 671.77 940.5 671.9 937.31 672.15 934.25 672.28 931.19 672.41 928.13 672.66 925.07 672.79 922.13 672.92 919.2 673.17 916.26 673.3 913.33 673.43 910.52 673.68 907.72 673.81 904.91 673.94 902.23 674.06 899.43 674.32 896.75 674.45 894.07 674.57 891.39 674.83 888.84 674.96 886.16 675.08 883.61 675.34 881.06 675.47 878.63 675.6 876.08 675.85 873.66 675.98 871.24 676.23 868.81 676.36 866.39 676.62 863.97 677 859.25 677.38 854.65 677.76 850.06 678.27 845.47 678.66 841 679.17 836.54 679.68 832.08 680.19 827.74 680.7 823.27 681.34 818.94 681.85 814.6 682.48 810.26 683.12 805.8 683.89 801.46 684.52 797 685.29 792.53 686.05 788.07 686.95 783.6 687.33 781.31 687.84 778.88 688.22 776.59 688.73 774.29 689.24 771.87 689.75 769.57 690.26 767.15 690.9 764.72 691.41 762.3 691.92 759.75 692.56 757.2 693.2 754.77 693.84 752.22 694.47 749.54 695.24 746.99 695.88 744.31 696.64 741.64 697.41 738.96 698.17 736.15 698.94 733.34 699.7 730.54 700.6 727.73 701.49 724.8 702.38 721.86 703.28 718.93 704.3 715.87 705.32 712.81 706.34 709.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1875.75 333.76 1862.74 334.22 1862.23 118.29 1888.56 118.51 1888.56 333.74 1875.75 333.76"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "marina"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1301.53 832.59 1304.97 832.59 1304.97 837.05 1301.53 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1309.69 832.59 1313.14 832.59 1309.69 837.05 1309.69 832.59"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1258.8,759.24l7.65,7.65h-7.65v-7.65ZM1266.45,759.24h-7.65l7.65,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1258.92,713.19l7.65,7.53h-7.65v-7.53ZM1266.58,713.19h-7.65l7.65,7.53v-7.53Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.05,666.63l7.65,7.65h-7.65v-7.65ZM1266.71,666.63h-7.65l7.65,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.18,605.4l7.65,7.65h-7.65v-7.65ZM1266.83,605.4h-7.65l7.65,7.65v-7.65Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M1417.31,545.02l50.05-50.85-4.08-4.08,47.07-47.71,4.08,3.95,25-25.38-3.7-3.57,13.78-13.9-52.83-46.67-40.16,40.29,2.55,2.42-10.46,10.59-1.91-1.91-1.53,1.53,1.91,1.79-15.43,15.56-1.79-1.91-1.53,1.53,1.79,1.91-15.31,15.43-1.91-1.91-1.53,1.53,1.91,1.91-15.56,15.69-1.4-1.4-17.22,17.35-.38-.26-3.95,3.95,16.2,14.03.04-.09c-2.24,5.36-2.56,11.33-.91,16.9l-.02.04-12.37-10.72-12.76,12.76-11.99-10.33,7.91-7.91,2.04,1.79,1.02-.89-2.17-1.91,1.15-1.15-4.34-3.83-11.99,12.25,4.59,4.21-17.86,18.24,17.86,15.56,42.48.13,5.49-5.87,10.97,9.31,2.93-3.32,4.85,4.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1273.47 825.44 1273.98 533.31 1442.99 361 1437.25 356.53 1266.83 530.78 1266.32 832.59 1862.15 832.59 1862.15 1176.74 1784.09 1176.74 1784.09 1187.97 1862.15 1187.97 1873.12 1187.97 1873.12 825.44 1273.47 825.44"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M979.71,161.32c-12.99,59.48-36.84,115.74-71.45,168.81l-1.26,1.53-1.27,1.66-1.27,1.53-1.26,1.53-1.27,1.53-1.14,1.53-1.26,1.53-1.14,1.53-1.14,1.53-2.41,2.95-2.29,2.81-2.16,2.82-2.28,2.81-2.03,2.69-2.16,2.69-4.06,5.11-2.03,2.57-1.91,2.43-1.9,2.43-1.9,2.31-1.78,2.31-1.78,2.3-1.77,2.18-1.78,2.18-1.65,2.18-1.64,2.05-1.65,2.05-1.52,2.05-1.52,1.92-1.52,1.93-1.52,1.92-1.53,1.92-1.39,1.79-1.39,1.78-1.39,1.66-1.27,1.79-1.39,1.66-1.27,1.53-1.14,1.66-1.26,1.53-1.27,1.53-1.14,1.4-1.13,1.53-1.14,1.4-1.01,1.41-1.01,1.27-1.14,1.41-1.01,1.27-.9,1.28-1.01,1.15-.89,1.14-.89,1.28-.89,1.15-.9,1.02-.89,1.15-.77,1.02-.89,1.02-.76,1.02-.77.89-.64,1.02-.76.89-.64.9-.77.89-.63.76-.64.9-.51.76-.64.77-.64.76-.51.77-.51.64-.51.76-.51.64-.51.64-.38.64-.51.63-.38.51-.39.64-.51.51-.38.51-.38.51-.26.51-.38.51-.25.51-.39.39-.25.38-.26.51-.38.38-.51.77-.38.76-.39.64-.38.64-.38.64-.26.51-.25.51-.26.51-.12.51-.26.38-.13.51-.12.38-.13.77-.26.76v.77l-.12.89-.13.89-.13.9-.13,1.02-.12,1.02-.13,1.15-.13,1.14-.13,1.28-.13,1.15-.12,1.27-.26,1.41-.13,1.4-.25,1.4-.26,1.41-.25,1.4-.26,1.53-.25,1.53-.38,1.53-.26,1.53-.38,1.66-.38,1.66-.51,1.53-.39,1.66-.51,1.66-.51,1.65-.51,1.66-.51,1.79-.64,1.66-.63,1.65-.64,1.66-.64,1.79-.64,1.66-.76,1.66-.77,1.65-1.39,3.33-.77,1.66-.89,1.66-.76,1.53-.77,1.66-.77,1.53-.89,1.53-.76,1.53-.77,1.53-.89,1.4-.77,1.4-.89,1.54-.77,1.27-.76,1.4-.77,1.28-.76,1.28-.77,1.14-.76,1.28-.77,1.15-.76,1.15-.64,1.14-1.52,2.18-1.27,2.18-1.39,2.18-1.27,2.18-1.26,2.18-.64,1.02-.64,1.14-.51,1.15-.64,1.15-.51,1.15-.63,1.27-.51,1.28-.51,1.28-.51,1.27-.26.77-.38.76-.26.77-.25.76-.38.89-.26.9-.38.89-.38,1.02-.39,1.02-.25.64-.13.51-.26.64-.25.64-.26.63-.25.64-.26.64-.25.76-.26.77-.25.64-.26.76-.38.9-.25.76-.39.89-.25.77-.38,1.02-.39.89-.38.9-.38,1.02-.39,1.02-.76,2.05-.51,1.15-.38,1.14-.51,1.15-.51,1.28-.51,1.15-.51,1.27-.51,1.28-.52,1.4-.63,1.4-.51,1.41-.64,1.4-.51,1.53-.64,1.53-.64,1.53-.76,1.66-.64,1.66-.64,1.66-.76,1.78-.77,1.79-.76,1.78-.77,1.93-.76,1.78-.9,2.05-.76,2.05-.9,2.06-.89,2.05-.89,2.17-.89,2.18-1.01,2.31-1.02,2.31-.89,2.3-1.01,2.44-1.14,2.43-1.01,2.43-1.14,2.56-1.01,2.69-1.13,2.69-1.14,2.69-1.27,2.82-1.14,2.81-1.26,2.82-1.27,2.94-1.26,3.07-1.4,3.08-1.39,3.07-1.26,3.2-1.52,3.32-1.4,3.33-1.39,3.33-1.52,3.45-1.52,3.45-1.52,3.59-14.34,8.69-.89,2.56-.89,2.69-.77,2.56-.89,2.56-.77,2.56-.76,2.56-.77,2.44-.64,2.43-.76,2.44-.64,2.43-.76,2.3-1.27,4.61-.64,2.3-.51,2.31-.64,2.31-.51,2.17-.63,2.18-.51,2.18-1.01,4.35-.51,2.05-.51,2.18-.39,2.05-.51,2.05-.38,2.05-.51,2.05-.38,2.05-.9,3.97-.76,3.96-.64,3.97-.76,3.83-.64,3.84-.64,3.84-.64,3.7-.51,3.84-.64,3.71-.51,3.71-1.01,7.42-.51,3.84-.38,3.7-.51,3.71-.38,3.84-.39,3.71-.51,3.84-.38,3.83-.38,3.84-.26,3.96-.38,3.97-.38,3.96-.26,4.09-.38,4.1-.25,4.22-.39,4.22-.25,4.34-.26,4.35-.25,2.18-.13,2.3-.13,2.31-.12,2.18-.13,2.31-.13,2.43-.13,2.3-.13,2.31-.12,2.43-.26,2.44-.13,2.43-.12,2.44-.13,2.43-.13,2.56-.13,2.43-.12,2.56-.13,2.57-.13,2.56-.25,2.69-.13,2.68-.13,2.57-.13,2.68-.12,2.69-.26,2.82-.13,2.69-.12,2.81-.13,2.82-.26,2.82-.12,2.94-.13,2.82-.26,2.94-.12,2.95-.26,3.07-.13,2.94-.25,3.07-.13,3.07-.25,3.08-.13,3.07-.26,3.2-.25,3.19-.13,3.2-.26,3.2-.25,3.2-.26,3.33-.12,3.32-.26,3.33-.25,3.46-.26,3.32-.51,6.91-.51,6.78-.51,7.04-.51,6.9-.64,7.04-1.01,14.07-.64,6.91-.51,7.04-.51,6.78-.63,6.9-.26,3.33-.25,3.46-.26,3.32-.25,3.33-.26,3.2-.25,3.32-.26,3.2-.25,3.2-.26,3.2-.26,3.07-.25,3.07-.26,3.08-.12,3.07-.26,2.94-.25,2.94-.26,2.82-.13,2.82-.25,2.81-.26,2.82-.12,2.69-.26,2.69-.25,2.69-.13,2.68-.26,2.57-.38,5.11-.25,5.24-.77,10.11-.76,10.23-.39,5.11-.25,2.69-.13,2.69-.26,2.56-.25,2.82-.13,2.69-.25,2.68-.26,2.82-.13,2.95-.25,2.81-.26,2.95-.25,2.94-.26,3.07-.25,3.07-.26,3.2-.25,3.2-.26,3.2-.25,3.33-.26,3.45-.38,3.45-.13,1.79-.12,1.79-.13,1.78-.26,1.79-.13,1.78-.12,1.93-.13,1.92-.26,1.92-.12,1.93-.13,1.92-.26,2.05-.12,1.92-.26,2.06-.13,2.17-.12,2.05-.26,2.18-.13,2.18-.25,2.18-.13,2.18-.25,2.3-.26,2.31-.13,2.31-.25,2.43-.26,2.43-.12,2.44-.26,2.43-.25,2.56-.26,2.56-.13,2.57-.25,2.68-.26,2.69-.25,2.82-.26,2.69-.25,2.81-.26,2.95-.25,2.94-.26,2.95-.25,3.07-.26,3.07-.25,3.07-.26,3.2-.38,3.2-.26,3.32-.25,3.33-.38,3.33-.26,3.45-.25,3.46-.39,3.58-.25,3.58-.39,3.71-.25,3.71-.38,3.83-.26,3.84-.38,3.97-.38,3.96-.39,3.96-.25,4.22-.38,4.1-.39,4.21-.76,8.7-.38,4.47-.39,4.48-.38,4.6-.38,4.6-.39,4.73-.38,4.86-.25,2.43-.26,2.44-.13,2.43-.25,2.56-.26,2.43-.12,2.57-.26,2.56-.25,2.56-.13,2.56-.26,2.56-.25,2.69-.13,2.69-.25,2.56-.26,2.69-.25,2.69-.26,2.81-.13,2.69-.25,2.82-.26,2.69-.25,2.81-.26,2.82-.25,2.82-.13,2.94-.26,2.82-.25,2.94-.26,2.94-.25,2.95-.26,2.94-.25,3.07-.26,2.95-.25,3.07-.26,3.07-.25,3.07-.26,3.07-.25,3.07-.26,3.2-.25,3.2-2.21,65.08-3.28,45.53s.99,38.6,27.74,68.7c31.71,35.67,84.55,63.41,215.34,87.19,75.06,13.65,257.61,11.89,257.61,11.89h619.93s871.6,0,871.6,0v48.88s-1619.67-3.96-1619.67-3.96c0,0-100.16-2.61-121.54-5.28-31.71-3.96-63.01-7.71-129.47-31.71-47.56-17.17-75.3-34.35-75.3-34.35l-58.73-43.82-14.26,153.47-78.28.99,36.39-360.09,6.11-40.63.51-4.22.63-4.22.51-4.09.51-4.09.51-4.22.52-3.97.51-4.09.51-3.96.38-4.1,1.01-7.92.51-3.84.51-3.97.38-3.83.51-3.84.51-3.84.39-3.83.51-3.84.38-3.71.51-3.71.38-3.71.51-3.71.38-3.71.51-3.58.39-3.71.38-3.58.51-3.58.38-3.58.39-3.46.38-3.58.51-3.45.38-3.45.38-3.46.39-3.45.38-3.46.76-6.65.77-6.78.76-6.53.77-6.52.64-6.4.76-6.4.64-6.27,1.27-12.27.63-6.02.64-6.01.64-5.89.64-5.89.64-5.76.51-5.63.63-5.64.51-5.5.51-5.51.51-5.5.64-5.37.51-5.24.51-5.24.39-5.11.51-5.11.51-5.12.38-4.98.51-4.86.38-4.85.51-4.86.38-4.86.39-4.6.38-4.73.38-4.6.39-4.61.38-4.47.38-4.47.38-4.48.39-4.35.25-4.34.38-4.22.39-4.35.25-4.22.26-4.09.38-4.09.25-4.09.26-4.1.38-4.09.26-3.96.25-3.97.26-3.83.25-3.97.26-3.84.25-3.83.26-3.84.25-3.71.26-3.71.13-3.71.25-3.71.26-3.7.25-3.59.13-3.71.25-3.58.13-3.58.26-3.45.12-3.58.26-3.46.13-3.45.25-3.46.13-3.45.25-3.46.13-3.32.13-3.33.25-3.33.13-3.32.13-3.33.25-3.2.13-3.32.39-9.6.38-6.27.25-6.27.26-6.02.38-6.14.26-5.89.25-6.01.26-5.76.25-5.76.38-5.64.26-5.63.25-5.63.26-5.37.25-5.5.39-5.24.25-5.37.38-5.24.26-5.11.38-5.12.26-5.11.38-4.98.38-4.99.39-4.85.38-4.86.38-4.86.38-4.73.51-4.73.39-4.73.51-4.6.51-4.6.38-4.48.51-4.6.51-4.35.51-4.47,1.01-8.7.64-4.34.51-4.22.51-4.09.51-4.22.51-4.09.51-4.1.64-3.96.51-3.97.51-3.96.51-3.84.51-3.83.51-3.84.38-3.71.51-3.71.51-3.58.38-3.58.52-3.58.38-3.59.38-3.45.38-3.33.39-3.45.38-3.33.25-3.2.39-3.19.25-3.2.26-3.2.25-3.07.26-3.08.12-2.94.13-2.94.13-2.95.13-2.94.12-2.82.13-2.81v-15.99l-.13-2.56v-2.56l-.12-2.56-.13-2.44-.13-2.56-.13-2.43-.12-2.43-.13-2.31-.38-4.73-.39-4.73-.38-4.6-.38-4.6-.51-4.61-.51-4.47-1.01-9.09-1.01-8.95-.64-4.47-.51-4.48-.51-4.34-.64-4.35-.51-4.22-.64-4.22-.25-2.05-.26-2.05-.25-2.05-.39-1.92-.25-2.06-.26-1.92-.25-1.92-.26-1.93-.38-1.78-.25-1.93-.26-1.78-.25-1.79-.26-1.66-.25-1.65-.39-1.66-.25-1.66-.26-1.53-.25-1.53-.26-1.53-.25-1.53-.26-1.41-.25-1.27-.26-1.4-.25-1.28-.26-1.28-.38-1.27-.26-1.15-.25-1.28-.26-1.14-.25-1.02-.38-1.15-.26-1.15-.38-1.02-.26-1.02-.76-2.05-.64-1.93-.89-1.92-.9-1.92-.89-1.93-1.01-1.78-.51-1.02-.64-.89-.51-.9-.63-1.02-.64-.89-.77-1.02-.64-.89-.76-1.02-.77-1.03-.76-1.02-.77-1.02-.89-1.02-.89-1.02-1.01-1.14-1.01-1.15-1.01-1.15-1.27-1.15-1.14-1.15-.76-.63-.64-.64-.64-.64-.76-.64-.77-.64-.77-.76-.89-.64-.76-.64-.9-.76-.89-.64-.89-.77-1.01-.76-.9-.77-1.01-.76-1.13-.77-1.01-.76-1.14-.77-1.14-.76-1.27-.9-1.13-.89-1.27-.76-1.39-.9-1.27-.89-1.39-.89-1.52-.9-1.4-1.02-1.52-.89-1.64-1.02-1.53-.89-1.64-1.02-1.78-1.02-1.78-1.02-1.77-1.15-1.9-1.02-1.78-1.15-2.03-1.02-4.06-2.31-2.16-1.15-2.16-1.27-2.16-1.15-2.28-1.27-2.42-1.28-2.28-1.15-2.55-1.4-2.54-1.28-2.54-1.27-2.67-1.41-2.67-1.4-2.79-1.4-2.8-1.41-2.91-1.4-2.92-1.53-3.04-1.53-3.04-1.53-3.17-1.53-334.31-129.32-95.47-32.51.88-153.25,928.87-11.45Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "903.16 879.53 957.25 880.17 957.25 874.3 903.16 873.71 903.16 873.66 894.74 873.53 894.74 873.61 863.87 873.28 863.87 876.34 894.71 876.72 894.07 936.67 863.24 936.42 863.24 939.48 894.04 939.73 893.45 995.73 862.6 995.35 862.6 998.41 893.42 998.79 893.14 1025.2 862.34 1024.95 862.21 1028.01 893.08 1028.26 893.11 1027.58 892.82 1055.56 861.96 1055.18 861.96 1058.24 892.78 1058.62 892.5 1085.15 861.7 1084.9 861.58 1087.96 892.45 1088.21 892.48 1087.42 892.19 1114.87 861.32 1114.62 861.32 1117.68 892.16 1117.94 891.87 1144.72 861.07 1144.34 860.94 1147.4 891.81 1147.78 891.85 1146.74 891.55 1174.96 899.97 1175.08 900.35 1138.91 900.35 1142.3 944.11 1142.81 944.11 1138.09 900.37 1137.58 900.74 1102.74 900.74 1104.92 944.49 1105.44 944.49 1100.72 900.76 1100.21 901.12 1066.57 901.12 1068.32 944.87 1068.83 944.87 1064.11 901.15 1063.6 901.5 1030.4 901.5 1030.94 945.26 1031.45 945.26 1026.73 901.55 1026.22 901.89 993.82 945.64 994.2 945.64 989.48 901.94 989.1 902.27 957.47 946.02 957.85 946.15 953.13 902.33 952.62 902.69 917.92 946.4 918.43 946.53 913.59 902.78 913.2 902.72 915.37 903.1 879.51 903.16 879.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "894.36 906.19 863.62 905.93 863.49 908.99 894.36 909.25 894.36 906.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "893.72 966.27 862.98 965.89 862.85 968.95 893.72 969.33 893.72 966.27"
})), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1304.97 832.59 1304.97 877.36 1309.69 877.36 1309.69 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1350.51 832.59 1350.51 877.36 1355.23 877.36 1355.23 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1396.31 832.59 1396.31 877.36 1401.03 877.36 1401.03 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1441.59 832.59 1441.59 877.36 1446.31 877.36 1446.31 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1487.13 832.59 1487.13 877.36 1491.85 877.36 1491.85 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1532.92 832.59 1532.92 877.36 1537.64 877.36 1537.64 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1578.59 832.59 1578.59 877.36 1583.31 877.36 1583.31 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1624.13 832.59 1624.13 877.36 1628.85 877.36 1628.85 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1669.92 832.59 1669.92 877.36 1674.64 877.36 1674.64 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1715.72 832.59 1715.72 877.36 1720.43 877.36 1720.43 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1761.25 832.59 1761.25 877.36 1765.97 877.36 1765.97 832.59"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "724.2 1138.47 760.17 1142.81 760.68 1138.73 724.71 1134.26"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "728.4 1104.29 764.38 1108.62 764.89 1104.54 728.91 1100.08"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "732.49 1070.48 768.46 1074.82 768.97 1070.61 733 1066.27"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "736.7 1036.04 772.67 1040.51 773.18 1036.3 737.21 1031.83"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "740.91 1001.98 776.88 1006.45 777.39 1002.24 741.42 997.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "763.1 820.72 792.18 824.29 792.57 821.49 763.36 817.92"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "759.53 850.06 788.61 853.63 789 850.83 759.78 847.25"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "755.83 879.91 784.91 883.48 785.3 880.68 756.21 877.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "752.13 909.76 781.34 913.33 781.6 910.52 752.51 906.95"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "748.56 939.48 777.64 943.05 778.03 940.37 748.81 936.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "744.86 969.58 773.94 973.16 774.33 970.35 745.24 966.78"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1862.15 1129.03 1797.61 1129.03 1797.61 1133.88 1862.15 1133.88"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1862.15 1080.94 1797.61 1080.94 1797.61 1085.66 1862.15 1085.66"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1862.15 1032.85 1797.61 1032.85 1797.61 1037.57 1862.15 1037.57"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1862.15 984.64 1797.61 984.64 1797.61 989.36 1862.15 989.36"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-9",
  points: "1862.15 936.55 1797.61 936.55 1797.61 941.27 1862.15 941.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "765.27 802.74 756.98 801.72 710.29 1182.99 710.04 1184.52 1077.92 1188.35 1077.92 1187.97 1077.92 1176.74 1077.92 1177 719.99 1173.17 765.27 802.74"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 1888.56,
  y: 118.51,
  width: 5.87,
  height: 703.36
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "1873.12 825.44 1873.12 1187.97 1873.12 1210.8 1870.83 1210.8 1870.83 1228.53 1880.14 1228.53 1880.14 825.44 1873.12 825.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1332.91 789.98 1332.91 777.99 1304.85 777.99 1304.85 731.18 1343.88 731.18 1343.88 789.98 1332.91 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1378.19 789.98 1378.19 777.99 1350.13 777.99 1350.13 731.18 1389.04 731.18 1389.04 789.98 1378.19 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1424.11 789.98 1424.11 777.99 1396.05 777.99 1396.05 731.18 1435.08 731.18 1435.08 789.98 1424.11 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1469.65 789.98 1469.65 777.99 1441.59 777.99 1441.59 731.18 1480.62 731.18 1480.62 789.98 1469.65 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1515.06 789.98 1515.06 777.99 1487 777.99 1487 731.18 1526.03 731.18 1526.03 789.98 1515.06 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1560.73 789.98 1560.73 777.99 1532.67 777.99 1532.67 731.18 1571.7 731.18 1571.7 789.98 1560.73 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1606.27 789.98 1606.27 777.99 1578.21 777.99 1578.21 731.18 1617.24 731.18 1617.24 789.98 1606.27 789.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1669.67 777.99 1669.67 731.18 1708.7 731.18 1708.7 789.98 1697.73 789.98 1697.73 777.99 1669.67 777.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1715.33 777.99 1715.33 731.18 1754.37 731.18 1754.37 789.98 1743.4 789.98 1743.4 777.99 1715.33 777.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1760.87 777.99 1760.87 731.18 1799.9 731.18 1799.9 789.98 1788.93 789.98 1788.93 777.99 1760.87 777.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1806.67 777.99 1806.67 731.18 1845.7 731.18 1845.7 789.98 1834.73 789.98 1834.73 777.99 1806.67 777.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-28",
  points: "1431.77 530.27 1427.69 526.19 1448.22 505.4 1452.3 509.48 1431.77 530.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "1528.84 428.35 1537.77 419.29 1539.43 420.95 1530.56 429.95 1528.84 428.35"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 1763.93,
  y1: 519.3,
  x2: 1771.71,
  y2: 519.43
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "1767.38 549.53 1767.38 546.34 1781.28 546.34 1781.28 550.93 1796.84 550.93 1796.84 565.86 1789.57 565.86 1789.57 675.69 1731.92 675.69 1731.92 669.56 1729.11 669.56 1729.11 666.12 1731.92 666.12 1731.92 649.54 1743.65 649.54 1743.65 635.25 1783.07 635.25 1783.07 632.19 1735.23 632.19 1735.23 626.07 1729.11 626.07 1729.11 623.13 1732.3 623.13 1732.3 606.04 1747.35 606.04 1747.35 596.73 1732.3 596.73 1732.3 582.7 1736 582.7 1736 570.83 1756.66 570.83 1756.66 579.63 1762.91 579.63 1762.91 570.83 1783.07 570.83 1783.07 566.37 1743.52 566.37 1743.52 557.31 1764.95 557.31 1764.95 562.92 1767.63 562.92 1767.63 551.57 1767.38 551.57 1767.38 549.53"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1835.62 522.62 1835.62 494.55 1843.15 494.55 1843.15 481.67 1854.88 469.93 1858.07 469.93 1858.07 522.62 1835.62 522.62"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "1829.5 653.87 1852.46 653.87 1852.46 622.37 1848.89 622.37 1848.89 522.62 1829.5 522.62 1829.5 653.87"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-14",
  points: "1601.04 614.08 1619.66 614.33 1619.54 629 1600.91 628.75 1601.04 614.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M1726.45,527.46c.99,4.62.79,9.46-.64,14.06l-.06.13c-2.13.51-4.17,1.38-6.04,2.58l-.07-.08c-2.49,1.45-4.74,3.25-6.7,5.34l-.04.04-3.19-2.93.51-.51.51-.38.38-.51.51-.38.38-.38.38-.26.26-.38.38-.26.26-.26.26-.26.26-.13.26-.26.26-.13.26-.13.13-.26.13-.13.38-.13.26-.26.26-.13.13-.13.51-.26.26-.38.38-.38.38-.38.13-.26.26-.13.13-.26.26-.38.26-.26.26-.38.26-.38.26-.38.26-.51.26-.51.38-.64.26-.64.07-.05c.46-1.05.69-2.19.69-3.33l-.13.06v-4.21l5.48-.26h.02Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1573.13 613.06 1573.36 665.1 1521.82 665.23 1521.82 669.31 1558.69 669.18 1558.69 679.13 1515.19 679.26 1514.94 603.23 1500.39 590.09 1506.77 583.59 1505.62 582.57 1508.05 580.15 1509.07 581.17 1514.17 576.06 1513.02 575.04 1517.49 570.45 1521.31 574.02 1522.72 572.62 1534.2 582.95 1639.94 475.67 1635.74 471.59 1645.05 462.28 1643.52 460.88 1652.57 451.82 1655.76 455.01 1658.82 451.95 1667.5 459.47 1670.3 456.16 1689.31 472.36 1685.48 476.57 1690.46 480.65 1677.06 495.19 1681.27 499.27 1675.15 505.01 1678.34 507.82 1677.32 508.84 1676.04 507.69 1659.08 525.04 1669.76 534.35 1668.39 535.75 1657.8 526.44 1648.24 536.14 1650.76 538.34 1650.76 538.34 1642.37 546.6 1632.29 537.41 1630.76 538.94 1607.54 517 1599.89 524.91 1615.84 538.82 1616.98 537.67 1635.74 554.76 1628.59 560.88 1632.04 564.97 1618.26 576.83 1611.24 568.79 1603.21 575.68 1610.73 584.23 1600.15 594.94 1597.6 592.65 1590.83 599.41 1582.93 591.88 1581.27 593.54 1556.9 570.32 1552.69 574.53 1572.72 593.54 1565.96 600.68 1568.26 602.85 1568.26 613.06 1573.1 613.06 1573.13 613.06"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1320.79 592.65 1371.56 593.03 1371.3 629 1308.42 628.49 1308.42 618.41 1320.54 618.41 1320.79 592.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1320.79 634.49 1371.56 634.87 1371.3 670.84 1308.42 670.33 1308.42 660.25 1320.54 660.38 1320.79 634.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "1371.56 550.81 1371.3 586.78 1308.42 586.27 1308.42 576.19 1320.54 576.32 1320.79 550.42 1371.56 550.81"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "1601.04 614.08 1619.66 614.33 1619.54 629 1600.91 628.75 1601.04 614.08"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 1759.72,
  y: 549.53,
  width: 7.65,
  height: 2.04
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "1736 575.94 1728.98 575.94 1728.98 579.63 1732.3 579.63 1732.3 582.7 1736 582.7 1736 575.94"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "1664.18 550.04 1648.24 536.14 1657.8 526.44 1668.39 535.75 1669.76 534.35 1675.02 538.94 1664.18 550.04"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "1659.08 525.04 1669.76 534.35 1687.78 515.98 1678.34 507.82 1677.32 508.84 1676.04 507.69 1659.38 524.73"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1730.85,543.07v.13c4.95-.46,9.4,3.01,10.15,7.92v.03s.13-.02.13-.02v-.03c-.76-4.98-5.27-8.5-10.27-8.03Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1741.12,551.1v.03l1.27-.2v-.02c-.86-5.63-5.94-9.61-11.61-9.11l.07,1.28c5.01-.47,9.52,3.05,10.27,8.03Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1730.85,543.2l.06,1.15c4.35-.43,8.28,2.62,8.94,6.95v.03s1.14-.18,1.14-.18v-.03c-.76-4.91-5.21-8.38-10.15-7.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1739.73,551.31c-.65-4.27-4.53-7.26-8.81-6.84l.07,1.28c3.62-.39,6.93,2.14,7.48,5.75v.04s1.28-.2,1.28-.2v-.03Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1730.73,541.03l.03.77c5.67-.51,10.76,3.48,11.62,9.11l.76-.12c-.92-6.02-6.35-10.29-12.41-9.76Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 1764.95,
  y: 557.31,
  width: 2.68,
  height: 5.61
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1273.98 533.31 1303 503.72 1298.03 498.88 1266.83 530.78 1266.76 573.26 1273.91 573.26 1273.98 533.31"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1462.76 832.59 1470.42 832.59 1470.42 840.24 1462.76 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1417.23 832.59 1424.88 832.59 1424.88 840.24 1417.23 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1417.23 832.59 1424.88 840.24 1417.23 840.24 1417.23 832.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1289.41,832.59l7.65,7.65h-7.65v-7.65ZM1297.06,832.59h-7.65l7.65,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1326.15 832.59 1333.8 840.24 1326.15 840.24 1326.15 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1371.94 832.59 1379.6 840.24 1371.94 840.24 1371.94 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1462.76 832.59 1470.42 840.24 1462.76 840.24 1462.76 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "1417.23 832.59 1424.88 840.24 1417.23 840.24 1417.23 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1355.23 832.59 1358.68 832.59 1355.23 837.05 1355.23 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1862.15 1125.59 1862.15 1129.03 1857.56 1129.03 1862.15 1125.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1857.56 1133.88 1862.15 1133.88 1862.15 1137.33 1857.56 1133.88"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1862.15 1077.5 1862.15 1080.94 1857.56 1080.94 1862.15 1077.5"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1857.56 1085.66 1862.15 1085.66 1862.15 1089.11 1857.56 1085.66"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1862.15 1029.28 1862.15 1032.85 1857.56 1032.85 1862.15 1029.28"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1857.56 1037.57 1862.15 1037.57 1862.15 1041.02 1857.56 1037.57"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1862.15 981.19 1862.15 984.64 1857.56 984.64 1862.15 981.19"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1857.56 989.36 1862.15 989.36 1862.15 992.8 1857.56 989.36"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1862.15 932.97 1862.15 936.55 1857.56 936.55 1862.15 932.97"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1857.56 941.27 1862.15 941.27 1862.15 944.71 1857.56 941.27"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1392.86 832.59 1396.31 832.59 1396.31 837.05 1392.86 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1401.03 832.59 1404.47 832.59 1401.03 837.05 1401.03 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1438.02 832.59 1441.59 832.59 1441.59 837.05 1438.02 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1446.31 832.59 1449.75 832.59 1446.31 837.05 1446.31 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1483.68 832.59 1487.13 832.59 1487.13 837.05 1483.68 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1491.85 832.59 1495.29 832.59 1491.85 837.05 1491.85 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1529.48 832.59 1532.92 832.59 1532.92 837.05 1529.48 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1537.64 832.59 1541.09 832.59 1537.64 837.05 1537.64 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1575.14 832.59 1578.59 832.59 1578.59 837.05 1575.14 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1583.31 832.59 1586.75 832.59 1583.31 837.05 1583.31 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1620.68 832.59 1624.13 832.59 1624.13 837.05 1620.68 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1628.85 832.59 1632.29 832.59 1628.85 837.05 1628.85 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1666.48 832.59 1669.92 832.59 1669.92 837.05 1666.48 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1674.64 832.59 1678.21 832.59 1674.64 837.05 1674.64 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1712.27 832.59 1715.72 832.59 1715.72 837.05 1712.27 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1720.43 832.59 1723.88 832.59 1720.43 837.05 1720.43 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1757.81 832.59 1761.25 832.59 1761.25 837.05 1757.81 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1765.97 832.59 1769.42 832.59 1765.97 837.05 1765.97 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1748.12 832.59 1751.94 836.41 1748.12 836.41 1748.12 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1755.77 832.59 1755.77 836.41 1751.94 836.41 1755.77 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1748.12 836.41 1751.94 836.41 1748.12 840.24 1748.12 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1751.94 836.41 1755.77 836.41 1755.77 840.24 1751.94 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1725.79 832.59 1729.62 836.41 1725.79 836.41 1725.79 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1733.45 832.59 1733.45 836.41 1729.62 836.41 1733.45 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1725.79 836.41 1729.62 836.41 1725.79 840.24 1725.79 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1729.62 836.41 1733.45 836.41 1733.45 840.24 1729.62 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1702.58 832.59 1706.4 836.41 1702.58 836.41 1702.58 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1710.23 832.59 1710.23 836.41 1706.4 836.41 1710.23 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1702.58 836.41 1706.4 836.41 1702.58 840.24 1702.58 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1706.4 836.41 1710.23 836.41 1710.23 840.24 1706.4 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1680.25 832.59 1684.08 836.41 1680.25 836.41 1680.25 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1687.91 832.59 1687.91 836.41 1684.08 836.41 1687.91 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1680.25 836.41 1684.08 836.41 1680.25 840.24 1680.25 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1684.08 836.41 1687.91 836.41 1687.91 840.24 1684.08 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1645.56 832.59 1653.21 832.59 1653.21 840.24 1645.56 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1599.76 832.59 1607.42 832.59 1607.42 840.24 1599.76 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1554.22 832.59 1561.88 832.59 1561.88 840.24 1554.22 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1508.56 832.59 1516.21 832.59 1516.21 840.24 1508.56 832.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,907.46l3.83,7.65h-3.83v-7.65ZM1858.33,907.46h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,1055.43l3.83,7.65h-3.83v-7.65ZM1858.33,1055.43h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,1103.52l3.83,7.65h-3.83v-7.65ZM1858.33,1103.52h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,1151.74l3.83,7.65h-3.83v-7.65ZM1858.33,1151.74h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,947.9l3.83,3.83h-3.83v-3.83ZM1858.33,947.9h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1858.33,951.73l3.83,3.7h-3.83v-3.7ZM1862.15,951.73h-3.83l3.83,3.7v-3.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,970.09l3.83,3.83h-3.83v-3.83ZM1858.33,970.09h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1858.33,973.92l3.83,3.83h-3.83v-3.83ZM1862.15,973.92h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,995.99l3.83,3.83h-3.83v-3.83ZM1858.33,995.99h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1858.33,999.82l3.83,3.83h-3.83v-3.83ZM1862.15,999.82h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1854.5,1018.31l3.83,3.83h-3.83v-3.83ZM1858.33,1018.31h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1858.33,1022.14l3.83,3.83h-3.83v-3.83ZM1862.15,1022.14h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1854.5 1187.97 1862.15 1187.97 1862.15 1195.62 1854.5 1187.97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1317.35,479.25h-5.36,5.36ZM1311.86,473.89l5.49,5.36h-5.36l-.13-5.36Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1311.99 479.25 1311.99 479.37 1306.5 479.37 1311.99 479.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1311.99,484.73l-5.48-5.36h5.48v5.36ZM1311.99,484.73h0l-5.48-5.36,5.48,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.87,433.71h-5.49v.13l5.49-.13ZM1356.38,428.35l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1356.51,439.19l-5.48-5.36h5.36l.13,5.36ZM1356.51,439.19h0l-5.48-5.36,5.48,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1384.32,410.87h-5.49,5.49ZM1378.83,405.52l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1378.83,411h-5.36l5.48,5.23-.13-5.23ZM1378.83,410.87v.13h-5.36l5.36-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1428.83,365.33h-5.49,5.49ZM1423.35,359.98l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1423.35,365.46h-5.36l5.48,5.23-.13-5.23ZM1423.35,365.33v.13h-5.36l5.36-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1378.83,405.52l5.49,5.36h-5.49v-5.36ZM1384.32,410.87l-5.49-5.36,5.49,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1378.83,405.52v5.36h-5.23l5.23-5.36ZM1378.83,410.87v-5.36,5.36Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1373.47 410.87 1378.83 410.87 1373.47 411 1373.47 410.87"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1373.47,411h10.71l-5.23,5.23-5.48-5.23ZM1378.83,410.87l-5.36.13h10.71l-5.36-.13Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1378.83 410.87 1384.19 410.87 1384.19 411 1378.83 410.87"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1356.38,428.35l5.49,5.36h-5.49v-5.36ZM1361.87,433.71l-5.49-5.36,5.49,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1356.38,428.35v5.36h-5.23l5.23-5.36ZM1356.38,433.71v-5.36,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1356.38,433.71l5.36.13h-5.36v-.13ZM1361.87,433.71h-5.49l5.36.13.13-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1351.15,433.71l5.23.13h-5.23v-.13ZM1356.38,433.71h-5.23l5.23.13v-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1351.02,433.83h10.71l-5.23,5.36-5.48-5.36ZM1356.38,433.83h-5.36,10.71-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1311.86,473.89l5.49,5.36h-5.36l-.13-5.36ZM1317.35,479.25l-5.49-5.36,5.49,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1311.86,473.89l.13,5.36h-5.36l5.23-5.36ZM1311.99,479.25l-.13-5.36.13,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1311.99,479.25l5.23.13h-10.71l5.48-.13ZM1317.35,479.25h-5.36l5.23.13.13-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1306.5,479.37l.13-.13h5.36l-5.48.13ZM1306.5,479.37h0l.13-.13-.13.13Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1306.5 479.37 1317.22 479.37 1311.99 484.73 1306.5 479.37"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1423.35,359.98v5.36h-5.23l5.23-5.36ZM1428.83,365.33l-5.49-5.36v5.36h5.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1423.35,365.33l5.36.13h-10.71l5.36-.13ZM1428.71,365.33h-5.36l5.36.13v-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1417.99,365.46l.13-.13h5.23l-5.36.13ZM1417.99,365.46h0l.13-.13-.13.13Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1417.99 365.46 1428.71 365.46 1423.48 370.69 1417.99 365.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1554.22 832.59 1558.05 836.41 1554.22 836.41 1554.22 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1599.76 832.59 1603.59 836.41 1599.76 836.41 1599.76 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1645.56 832.59 1649.38 836.41 1645.56 836.41 1645.56 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1680.25 832.59 1687.91 832.59 1684.08 836.41 1680.25 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1702.58 832.59 1710.23 832.59 1706.4 836.41 1702.58 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1725.79 832.59 1733.45 832.59 1729.62 836.41 1725.79 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1748.12 832.59 1755.77 832.59 1751.94 836.41 1748.12 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1684.08 836.41 1687.91 840.24 1680.25 840.24 1684.08 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1706.4 836.41 1710.23 840.24 1702.58 840.24 1706.4 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1729.62 836.41 1733.45 840.24 1725.79 840.24 1729.62 836.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1751.94 836.41 1755.77 840.24 1748.12 840.24 1751.94 836.41"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1645.56,836.41l7.65,3.83h-7.65v-3.83ZM1649.38,836.41h-3.83l7.65,3.83-3.83-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1599.76,836.41l7.65,3.83h-7.65v-3.83ZM1603.59,836.41h-3.83l7.65,3.83-3.83-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1554.22,836.41l7.65,3.83h-7.65v-3.83ZM1558.05,836.41h-3.83l7.65,3.83-3.83-3.83Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1508.56 832.59 1516.21 840.24 1508.56 840.24 1508.56 832.59"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,907.46l3.83,7.65h-3.83v-7.65ZM1862.15,907.46h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,947.9l3.83,3.83h-3.83v-3.83ZM1862.15,947.9h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1854.5,951.73l3.83,3.7h-3.83v-3.7ZM1858.33,951.73h-3.83l3.83,3.7v-3.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,970.09l3.83,3.83h-3.83v-3.83ZM1862.15,970.09h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1854.5,973.92l3.83,3.83h-3.83v-3.83ZM1858.33,973.92h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,995.99l3.83,3.83h-3.83v-3.83ZM1862.15,995.99h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1854.5,999.82l3.83,3.83h-3.83v-3.83ZM1858.33,999.82h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,1018.31l3.83,3.83h-3.83v-3.83ZM1862.15,1018.31h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1854.5,1022.14l3.83,3.83h-3.83v-3.83ZM1858.33,1022.14h-3.83l3.83,3.83v-3.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,1055.43l3.83,7.65h-3.83v-7.65ZM1862.15,1055.43h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,1103.52l3.83,7.65h-3.83v-7.65ZM1862.15,1103.52h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1858.33,1151.74l3.83,7.65h-3.83v-7.65ZM1862.15,1151.74h-3.83l3.83,7.65v-7.65Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "1854.5 1187.97 1862.15 1195.62 1854.5 1195.62 1854.5 1187.97"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1763.93,544.05v5.48h3.44v-3.19h13.9v4.59h15.56v14.92h-7.27v113.91h22.58v-153.96l.13-.06c0-3.71-1.47-7.26-4.09-9.88-2.62-2.62-6.18-4.09-9.88-4.09h-.05l-19.99.04-2.05-.05c.96,1.58.98,3.55.06,5.15-.93,1.6-2.65,2.56-4.5,2.51h-.06s-7.78-.13-7.78-.13h.06c-5.83,1.22-10.01,6.36-10.01,12.31s4.18,11.09,10.01,12.3"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1371.94 832.59 1379.6 832.59 1379.6 840.24 1371.94 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1326.15 832.59 1333.8 832.59 1333.8 840.24 1326.15 832.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1347.07 832.59 1350.51 832.59 1350.51 837.05 1347.07 832.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1317.35,479.25h-5.36,5.36ZM1311.86,473.89l5.49,5.36h-5.36l-.13-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1311.99,484.73l-5.48-5.36h5.48v5.36ZM1311.99,484.73h0l-5.48-5.36,5.48,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.87,433.71h-5.49v.13l5.49-.13ZM1356.38,428.35l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1356.51,439.19l-5.48-5.36h5.36l.13,5.36ZM1356.51,439.19h0l-5.48-5.36,5.48,5.36Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 1356.38,
  y1: 428.35,
  x2: 1361.87,
  y2: 433.71
}), /*#__PURE__*/React.createElement("path", {
  d: "M1384.32,410.87h-5.49,5.49ZM1378.83,405.52l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1378.83,411h-5.36l5.48,5.23-.13-5.23ZM1378.83,410.87v.13h-5.36l5.36-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1428.83,365.33h-5.49,5.49ZM1423.35,359.98l5.49,5.36h-5.49v-5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1423.35,365.46h-5.36l5.48,5.23-.13-5.23ZM1423.35,365.33v.13h-5.36l5.36-.13Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "710.93 1177.76 745.24 1178.14 745.24 1184.89 709.85 1184.78 710.93 1177.76"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "buildings"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "811.79 656.73 890.18 658.06 900.75 647.93 906.47 653.21 987.94 576.59 978.25 565.58 980.01 482.35 938.62 445.36 944.78 438.31 930.69 426.86 1005.55 344.51 1077.88 264.7 1095.06 244.55 1205.48 344.51 1057.96 505.69 1072.93 518.02 1071.61 545.32 1053.11 563.82 1052.67 593.76 1078.65 621.5 954.91 739.08 931.13 714.86 920.12 721.47 921.44 753.17 822.36 751.85 821.92 684.92 812.67 685.36 811.79 656.73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-25",
  points: "1869.22 117.39 1868.48 332.24 1868.23 404.73 1777.08 483.01 1730.51 484 1555.98 332.91 1514.18 297.39 1693.41 117.72 1869.22 117.39"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "trees"
}, /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1884.2028 569.5399) scale(1.063)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1726.4434 518.8906) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1753.8766 503.2666) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1678.1563 653.073) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1703.2064 674.6428) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1730.5833 677.0026) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1745.7226 675.176) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1802.02 675.176) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1831.4098 675.6971) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1856.2359 655.8953) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1854.6441 639.9687) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1854.237 606.8917) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1855.291 562.8931) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1856.2144 545.6157) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1850.3089 514.8676) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1787.2297 672.3337) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1688.9351 678.7242) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1680.3934 674.0874) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1659.0896 657.5687) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1642.3758 546.2542) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1689.624 491.9613) rotate(33.2491) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1703.945 494.8898) rotate(33.2491) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1723.3088 494.8898) rotate(33.2491) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1615.5143 568.4983) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1599.2179 585.6647) rotate(-41.9514) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1586.1431 606.1687) rotate(-41.9514) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1565.0034 634.8845) rotate(-41.9514) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1582.293 656.7873) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1544.1982 702.0002) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1561.3926 707.6194) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1292.906 773.7177) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1311.0399 785.1803) rotate(-7.4519) scale(.6267)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1416.9566 704.6154) rotate(-7.4519) scale(.6267)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1507.9631 704.6154) rotate(-7.4519) scale(.6267)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1462.5931 710.5071) rotate(-7.4519) scale(.4624)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1470.9778 702.1362) rotate(-7.4519) scale(.5915)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1340.0656 774.918) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1391.7507 779.2578) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1443.5215 785.7049) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1370.9581 660.8913) rotate(-7.4519) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1367.3769 614.2373) rotate(-7.4519) scale(.6427)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1368.7671 569.0529) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1380.9629 534.1681) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1352.6548 532.4461) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1332.8168 532.4461) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1318.3932 522.4914) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1303.1005 534.4016) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1285.9949 538.5412) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1281.4027 563.6079) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1281.623 593.1495) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1281.623 616.5555) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1281.623 649.4413) rotate(-7.4519) scale(.5207)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1285.0725 676.6302) rotate(-7.4519) scale(.5576)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1615.6415 668.1554) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1650.4659 715.6333) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1650.4659 740.5197) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1650.4659 762.1131) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1646.9505 780.5467) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1659.5482 786.5654) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1682.6312 794.1509) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1734.2672 793.9674) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1713.7354 784.8574) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1786.6995 796.6705) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1765.4608 784.612) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1833.5776 795.332) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1810.5753 785.0553) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1810.5646 708.5) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1824.8704 711.7049) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1753.4495 706.0528) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1739.3666 711.5861) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1698.4921 711.8863) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1685.5258 708.4124) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1616.4055 780.5742) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1598.6958 793.8455) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1572.7631 783.8701) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1556.1493 794.1509) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1535.3283 786.1472) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1508.2595 793.7328) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1491.6389 788.7258) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1466.1553 793.0001) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1443.1523 802.0246) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1407.3668 792.8873) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1350.491 789.6669) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1615.3315 740.5197) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1615.3315 717.7059) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1607.4003 709.7748) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1591.2783 712.3231) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1615.3315 753.8021) rotate(-27.9017) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1322.5192 713.2829) rotate(-27.9017) scale(.3146)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1911.8339 521.2466) scale(1.063)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1902.6347 486.2981) rotate(-20.5174) scale(1.063)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1924.0201 422.5577) rotate(17.9828) scale(.9461)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2034.4127 718.4356) rotate(17.9828) scale(.8433)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1841.0523 1513.5363) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1622.8373 1515.8375) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1585.3254 1492.2045) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1552.174 1515.6686) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1528.5444 1476.8394) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1487.3702 1462.986) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1482.5742 1521.1325) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1410.3862 1479.1239) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1446.308 1517.0654) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1381.7459 1498.751) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1332.453 1490.8855) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1280.4905 1499.7341) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1110.3513 1525.3573) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(978.6266 1518.1085) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(822.7355 1518.1085) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(781.8628 1521.3014) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(649.4642 1516.8965) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(689.3192 1498.3497) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(638.1218 1463.0495) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(602.3742 1493.9607) rotate(17.9828) scale(1.0387)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(497.7695 1470.3786) rotate(17.9828) scale(1.0387)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(718.5913 1531.9193) rotate(17.9828) scale(.6723)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(863.671 1532.4786) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1065.3272 1533.8857) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1021.8153 1515.2672) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1251.0396 1520.5646) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1223.1643 1544.3503) rotate(17.9828) scale(.6383)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1015.1251 1554.039) rotate(17.9828) scale(.6383)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(900.3058 1523.5806) rotate(17.9828) scale(.6383)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1425.4435 1543.8617) rotate(17.9828) scale(.6383)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1877.3179 1504.7258) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1890.9419 1540.4168) rotate(17.9828) scale(.9049)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2089.9473 708.176) rotate(17.9828) scale(1.0432 .893)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1995.6973 635.7134) rotate(17.9828) scale(.8985)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2035.4255 685.9191) rotate(-9.2627) scale(.8601)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2100.4211 690.441) rotate(-9.2627) scale(.9649)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2087.0159 554.7132) rotate(-9.2627) scale(.8021)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2059.9268 545.9294) rotate(-9.2627) scale(.8021)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2038.4811 487.2602) rotate(-9.2627) scale(.8852)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1993.7738 458.89) rotate(-9.2627) scale(.9711)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1977.656 504.7482) rotate(-9.2627) scale(.9722)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1886.6674 603.2241) rotate(-9.2627) scale(.9722)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1906.7736 581.5146) rotate(-9.2627) scale(.7862)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1884.2402 710.4805) rotate(-9.2627) scale(.5981)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(2000.4126 549.814) rotate(-9.2627) scale(.9722)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1329.6537 709.7974) rotate(-36.5768) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1369.6169 717.4423) rotate(-27.9017) scale(.3146)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1376.7515 713.9567) rotate(-36.5768) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1928.9412 697.0994) scale(.901)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1892.3018 653.0493) scale(1.063)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(2112.3095 508.5407) scale(.8077)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1951.2126 732.0937) scale(1.0159)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1965.3297 476.8094) scale(1.063)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1969.2733 555.9369) scale(1.063)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1915.2835 637.1923) scale(1.063)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 60.97,
  height: 60.42,
  transform: "translate(1895.7293 725.5124) rotate(4.3294) scale(1.0869)",
  xlinkHref: "#Tree_1"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1102.1104 710.875) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1000.7739 697.8665) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1020.0206 679.0417) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1100.9833 691.887) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1102.2115 675.41) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1101.4236 657.098) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1101.2537 639.2843) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(813.18 521.13) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(815.09 502.86) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(820.82 485.17) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1122.3913 466.2201) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1133.0372 452.1439) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1145.9007 441.3182) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1159.721 429.6214) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1171.8385 416.1753) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(934.92 764.51) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(978.23 765.02) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1001.7383 764.3924) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1070.4756 686.2976) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1072.7559 671.5881) rotate(-25.4817) scale(.4765)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(737.56 744.87) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(756.73 745.65) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(755.57 726.52) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(754.37 666.3) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(761.47 648.11) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(774.19 602.89) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(794.37 602.63) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(811.88 602.25) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(833.64 603.77) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(859.54 635.66) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(855.37 616.62) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(851.02 602.69) rotate(-25.48) scale(.48)",
  xlinkHref: "#Tree_1_Small"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "bandp"
}, /*#__PURE__*/React.createElement("g", {
  id: "Berths"
}, /*#__PURE__*/React.createElement("g", {
  id: "B-1"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back",
  className: "cls-31",
  points: "1852.8 1211.6 1786.56 1211.78 1786.48 1193.45 1852.71 1193.27 1852.8 1211.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth",
  className: "cls-9",
  d: "M1854.5,1191.78l-69.82.19.1,21.06,69.82-.19-.1-21.06ZM1786.57,1211.66l-.09-18.33,66.23-.2.08,18.33-66.22.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat",
  className: "cls-9",
  d: "M1846.27,1196.5c.19.1.21.2.39.3,1.4.03,2.52.6,2.44,1.27l-.05,7.51c.08.65-1.05,1.28-2.44,1.37-.16.12-.15.23-.29.36-22.19.34-36.65.52-54.82-4.59,17.95-5.69,32.78-5.88,54.77-6.22Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-2"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-2",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.55 1175.08 1785.83 1175.27 1785.75 1156.93 1852.46 1156.74 1852.55 1175.08"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-2",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.26,1155.26l-70.33.19.11,21.06,70.33-.19-.1-21.06ZM1785.84,1175.14l-.09-18.34,66.71-.2.08,18.33-66.7.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-2",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1845.97,1159.98c.19.1.21.2.39.3,1.41.03,2.54.6,2.46,1.27l-.06,7.51c.08.65-1.06,1.28-2.46,1.37-.16.12-.15.23-.29.36-22.35.34-36.91.52-55.22-4.59,18.08-5.69,33.02-5.88,55.17-6.22Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-3"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-3",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.45 1153.74 1785.74 1153.92 1785.65 1135.87 1852.36 1135.69 1852.45 1153.74"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-3",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.16,1134.23l-70.33.19.11,20.73,70.33-.19-.1-20.73ZM1785.74,1153.8l-.09-18.05,66.71-.2.08,18.04-66.7.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-3",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1845.88,1138.87c.19.1.21.19.39.3,1.41.03,2.54.59,2.46,1.25l-.06,7.4c.08.64-1.06,1.26-2.46,1.35-.16.12-.15.23-.29.35-22.35.33-36.91.51-55.22-4.52,18.08-5.6,33.02-5.79,55.17-6.12Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-4"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-4",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.63 1127.48 1786 1127.66 1785.91 1109.16 1852.54 1108.98 1852.63 1127.48"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-4",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.34,1107.48l-70.25.19.11,21.25,70.24-.19-.1-21.25ZM1786,1127.54l-.09-18.5,66.63-.2.08,18.49-66.62.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-4",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.07,1112.24c.19.1.21.2.39.31,1.4.03,2.54.61,2.46,1.28l-.06,7.58c.08.66-1.06,1.29-2.45,1.38-.16.12-.15.24-.29.36-22.32.34-36.87.52-55.15-4.63,18.06-5.74,32.98-5.93,55.1-6.27Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-5"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-5",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.55 1105.87 1785.83 1106.05 1785.75 1087.48 1852.46 1087.29 1852.55 1105.87"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-5",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.26,1085.79l-70.33.19.11,21.33,70.33-.19-.1-21.33ZM1785.84,1105.93l-.09-18.57,66.71-.2.08,18.56-66.7.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-5",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1845.97,1090.57c.19.1.21.2.39.31,1.41.03,2.54.61,2.46,1.28l-.06,7.61c.08.66-1.06,1.3-2.46,1.39-.16.12-.15.24-.29.36-22.35.34-36.91.53-55.22-4.65,18.08-5.76,33.02-5.96,55.17-6.3Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-6"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-6",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.69 1079.28 1785.92 1079.47 1785.83 1060.95 1852.6 1060.76 1852.69 1079.28"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-6",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.4,1059.26l-70.39.19.11,21.27,70.39-.19-.1-21.28ZM1785.92,1079.34l-.09-18.52,66.77-.2.08,18.52-66.76.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-6",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.11,1064.02c.2.1.21.2.39.31,1.41.03,2.54.61,2.46,1.28l-.06,7.59c.08.66-1.06,1.29-2.46,1.38-.16.12-.15.24-.29.36-22.37.34-36.94.52-55.26-4.64,18.1-5.75,33.05-5.94,55.21-6.28Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-7"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-7",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.51 1057.84 1785.79 1058.03 1785.7 1039.45 1852.42 1039.27 1852.51 1057.84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-7",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.22,1037.76l-70.33.19.11,21.33,70.33-.19-.1-21.33ZM1785.8,1057.9l-.09-18.57,66.71-.2.08,18.56-66.7.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-7",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1845.93,1042.54c.19.1.21.2.39.31,1.41.03,2.54.61,2.46,1.28l-.06,7.61c.08.66-1.06,1.3-2.46,1.39-.16.12-.15.24-.29.36-22.35.34-36.91.53-55.22-4.65,18.08-5.76,33.02-5.96,55.17-6.3Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-8"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-8",
  "data-name": "Back",
  className: "cls-31",
  x: 1809.96,
  y: 988.58,
  width: 18.69,
  height: 66.91,
  transform: "translate(794.1248 2839.5812) rotate(-89.901)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-8",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.61,1011.25l-70.54-.13-.06,21.47,70.54.13.06-21.47ZM1785.83,1031.2l.05-18.69,66.91.1-.06,18.68-66.9-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-8",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.26,1016.02c.19.1.21.2.39.31,1.41.04,2.55.63,2.46,1.3l-.11,7.66c.07.67-1.07,1.3-2.47,1.39-.16.12-.15.24-.3.36-22.42.24-37.03.36-55.35-4.93,18.18-5.72,33.16-5.85,55.38-6.09Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-9"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-9",
  "data-name": "Back",
  className: "cls-31",
  x: 1809.84,
  y: 966.89,
  width: 18.69,
  height: 66.84,
  transform: "translate(815.7307 2817.7596) rotate(-89.9008)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-9",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.44,989.51l-70.46-.13-.06,21.47,70.46.13.06-21.47ZM1785.75,1009.47l.05-18.69,66.84.1-.06,18.68-66.82-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-9",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.11,994.28c.19.1.21.2.39.31,1.41.04,2.54.63,2.46,1.3l-.11,7.66c.07.67-1.07,1.3-2.47,1.39-.16.12-.15.24-.3.36-22.39.24-36.99.36-55.28-4.93,18.16-5.72,33.13-5.85,55.32-6.09Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-10"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-10",
  "data-name": "Back",
  className: "cls-31",
  x: 1809.84,
  y: 940.42,
  width: 18.69,
  height: 66.84,
  transform: "translate(842.2005 2791.3355) rotate(-89.9008)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-10",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.44,963.04l-70.46-.13-.06,21.47,70.46.13.06-21.47ZM1785.75,983l.05-18.69,66.84.1-.06,18.68-66.82-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-10",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.11,967.81c.19.1.21.2.39.31,1.41.04,2.54.63,2.46,1.3l-.11,7.66c.07.67-1.07,1.3-2.47,1.39-.16.12-.15.24-.3.36-22.39.24-36.99.36-55.28-4.93,18.16-5.72,33.13-5.85,55.32-6.09Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-11"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-11",
  "data-name": "Back",
  className: "cls-31",
  x: 1809.88,
  y: 918.74,
  width: 18.69,
  height: 66.76,
  transform: "translate(863.9569 2769.6936) rotate(-89.9007)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-11",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.44,941.32l-70.38-.13-.06,21.47,70.37.13.06-21.47ZM1785.83,961.28l.05-18.69,66.76.1-.06,18.68-66.75-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-11",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1846.12,946.1c.19.1.21.2.39.31,1.41.04,2.54.63,2.45,1.3l-.11,7.66c.07.67-1.07,1.3-2.47,1.39-.16.12-.15.24-.3.36-22.37.24-36.94.36-55.22-4.93,18.14-5.72,33.09-5.85,55.25-6.09Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-12"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Back-12",
  "data-name": "Back",
  className: "cls-31",
  points: "1852.55 922.62 1785.83 922.83 1785.75 902.31 1852.46 902.1 1852.55 922.62"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-12",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1854.26,900.44l-70.33.21.11,23.56,70.33-.21-.1-23.57ZM1785.84,922.69l-.09-20.51,66.71-.22.08,20.51-66.7.23Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-12",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1845.97,905.72c.19.11.21.22.39.34,1.41.03,2.54.68,2.46,1.42l-.06,8.41c.08.73-1.06,1.43-2.46,1.53-.16.13-.15.26-.29.4-22.35.38-36.91.58-55.22-5.14,18.08-6.37,33.02-6.58,55.17-6.96Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-13"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-13",
  "data-name": "Back",
  className: "cls-31",
  x: 1744.05,
  y: 841.63,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 6.16)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-13",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1742.67,840.42l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1760.03,887.53l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-13",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1746.79,846.12c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-14"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-14",
  "data-name": "Back",
  className: "cls-31",
  x: 1721.92,
  y: 841.62,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 6.09)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-14",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1720.54,840.41l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1737.9,887.52l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-14",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1724.66,846.11c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-15"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-15",
  "data-name": "Back",
  className: "cls-31",
  x: 1698.42,
  y: 841.56,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-15",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1697.04,840.36l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1714.4,887.47l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-15",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1701.16,846.06c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-16"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-16",
  "data-name": "Back",
  className: "cls-31",
  x: 1676.24,
  y: 841.51,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.93)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-16",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1674.86,840.3l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1692.21,887.41l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-16",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1678.98,846c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-17"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-17",
  "data-name": "Back",
  className: "cls-31",
  x: 1652.73,
  y: 841.48,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.84)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-17",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1651.35,840.27l.17,48.43,18.38-.07-.16-48.43-18.39.07ZM1668.71,887.39l-16,.06-.17-45.94,16-.05.18,45.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-17",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1655.47,845.98c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.03-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-18"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-18",
  "data-name": "Back",
  className: "cls-31",
  x: 1630.46,
  y: 841.59,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.76)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-18",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1629.09,840.38l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1646.44,887.5l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-18",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1633.2,846.09c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-19"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-19",
  "data-name": "Back",
  className: "cls-31",
  x: 1606.93,
  y: 841.48,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.68)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-19",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1605.55,840.27l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1622.91,887.39l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-19",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1609.67,845.98c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-20"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-20",
  "data-name": "Back",
  className: "cls-31",
  x: 1584.75,
  y: 841.59,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-20",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1583.37,840.38l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1600.73,887.5l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-20",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1587.49,846.09c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-21"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-21",
  "data-name": "Back",
  className: "cls-31",
  x: 1561.4,
  y: 841.54,
  width: 16.01,
  height: 45.94,
  transform: "translate(-1.36 2.48)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-21",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1560.06,840.31l.07,48.43,18.38-.04-.07-48.42-18.39.04ZM1577.33,887.46l-16,.03-.08-45.94,16-.02.09,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-21",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1564.17,846.02c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.05c.57-.05,1.12.73,1.19,1.69.1.11.2.1.31.2.27,15.39.4,25.42-4.08,38.01-4.94-12.46-5.09-22.75-5.35-38Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-22"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-22",
  "data-name": "Back",
  className: "cls-31",
  x: 1539.16,
  y: 841.65,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.44)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-22",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1537.78,840.44l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1555.14,887.55l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-22",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1541.9,846.14c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-23"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-23",
  "data-name": "Back",
  className: "cls-31",
  x: 1515.51,
  y: 841.54,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.36)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-23",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1514.14,840.33l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1531.49,887.44l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-23",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1518.26,846.03c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-24"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-24",
  "data-name": "Back",
  className: "cls-31",
  x: 1493.33,
  y: 841.65,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-24",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1491.95,840.44l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1509.31,887.55l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-24",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1496.07,846.14c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-25"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-25",
  "data-name": "Back",
  className: "cls-31",
  x: 1469.94,
  y: 841.45,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-25",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1468.56,840.25l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1485.92,887.36l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-25",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1472.68,845.95c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-26"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-26",
  "data-name": "Back",
  className: "cls-31",
  x: 1447.75,
  y: 841.56,
  width: 16.01,
  height: 45.94,
  transform: "translate(-3.03 5.12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-26",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1446.38,840.36l.17,48.43,18.38-.07-.16-48.42-18.39.07ZM1463.73,887.47l-16,.06-.17-45.94,16-.05.18,45.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-26",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1450.49,846.06c.09-.13.17-.14.26-.27.03-.97.53-1.75,1.11-1.69l6.56.04c.57-.05,1.12.73,1.2,1.69.1.11.2.1.31.2.3,15.39.45,25.42-4.01,38.02-4.97-12.45-5.13-22.74-5.43-37.99Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-27"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-27",
  "data-name": "Back",
  className: "cls-31",
  x: 1424.47,
  y: 841.48,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-27",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1423.19,840.24l-.03,48.43h18.38s.03-48.42.03-48.42h-18.39ZM1440.36,887.42h-16s0-45.94,0-45.94h16s0,45.94,0,45.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-27",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1427.28,845.96c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.11.73,1.19,1.7.1.11.2.11.31.2.23,15.39.35,25.42-4.16,38-4.92-12.47-5.04-22.76-5.28-38.01Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-28"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-28",
  "data-name": "Back",
  className: "cls-31",
  x: 1402.46,
  y: 841.48,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-28",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1401.15,840.25l.04,48.43,18.38-.02-.03-48.42-18.39.02ZM1418.38,887.41l-16,.02-.05-45.94h16s.06,45.92.06,45.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-28",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1405.25,845.96c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.12.73,1.19,1.69.1.11.2.1.31.2.25,15.39.38,25.42-4.11,38.01-4.93-12.46-5.07-22.75-5.33-38Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-29"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-29",
  "data-name": "Back",
  className: "cls-31",
  x: 1379.08,
  y: 841.51,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-29",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1377.8,840.26l-.03,48.43h18.38s.03-48.42.03-48.42h-18.39ZM1394.97,887.44h-16s0-45.94,0-45.94h16s0,45.94,0,45.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-29",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1381.89,845.98c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.11.73,1.19,1.7.1.11.2.11.31.2.23,15.39.35,25.42-4.16,38-4.92-12.47-5.04-22.76-5.28-38.01Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-30"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-30",
  "data-name": "Back",
  className: "cls-31",
  x: 1356.57,
  y: 841.47,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-30",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1355.27,840.23l.03,48.43,18.38-.02-.02-48.42-18.39.02ZM1372.49,887.39h-16s-.04-45.92-.04-45.92h16s.05,45.92.05,45.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-30",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1359.37,845.95c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.12.73,1.19,1.69.1.11.2.1.31.2.25,15.39.38,25.42-4.12,38.01-4.93-12.47-5.07-22.75-5.32-38Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-31"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-31",
  "data-name": "Back",
  className: "cls-31",
  x: 1333.32,
  y: 841.48,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-31",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1332.04,840.23l-.03,48.43h18.38s.03-48.42.03-48.42h-18.39ZM1349.21,887.41h-16s0-45.94,0-45.94h16s0,45.94,0,45.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-31",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1336.13,845.95c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.11.73,1.19,1.7.1.11.2.11.31.2.23,15.39.35,25.42-4.16,38-4.92-12.47-5.04-22.76-5.28-38.01Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-32"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-32",
  "data-name": "Back",
  className: "cls-31",
  x: 1311.12,
  y: 841.49,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-32",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1309.81,840.26l.03,48.43,18.38-.02-.02-48.42-18.39.02ZM1327.03,887.42h-16s-.04-45.92-.04-45.92h16s.05,45.92.05,45.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-32",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1313.91,845.97c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.12.73,1.19,1.69.1.11.2.1.31.2.25,15.39.38,25.42-4.12,38.01-4.93-12.47-5.07-22.75-5.32-38Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-33"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-33",
  "data-name": "Back",
  className: "cls-31",
  x: 1285.33,
  y: 841.51,
  width: 16.01,
  height: 45.94
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-33",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1284.02,840.27l.03,48.43,18.38-.02-.02-48.42-18.39.02ZM1301.24,887.44h-16s-.04-45.92-.04-45.92h16s.05,45.92.05,45.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-33",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1288.12,845.99c.09-.13.17-.14.27-.27.03-.97.53-1.75,1.11-1.69l6.56.06c.57-.05,1.12.73,1.19,1.69.1.11.2.1.31.2.25,15.39.38,25.42-4.12,38.01-4.93-12.47-5.07-22.75-5.32-38Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-34"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-34",
  "data-name": "Back",
  className: "cls-31",
  x: 1241.64,
  y: 760.37,
  width: 15.91,
  height: 45.69,
  transform: "translate(-2.74 4.39)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-34",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1240.27,759.17l.17,48.17,18.28-.07-.16-48.17-18.28.07ZM1257.52,806.03l-15.91.06-.17-45.69,15.91-.05.18,45.68Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-34",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1244.36,764.85c.09-.13.17-.14.26-.27.03-.96.52-1.74,1.1-1.69l6.52.04c.57-.05,1.11.72,1.19,1.68.1.11.2.1.31.2.29,15.31.45,25.28-3.98,37.82-4.94-12.39-5.1-22.62-5.4-37.79Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-35"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-35",
  "data-name": "Back",
  className: "cls-31",
  x: 1241.6,
  y: 707.01,
  width: 16.03,
  height: 45.63,
  transform: "translate(-2.58 4.43)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-35",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1240.21,705.81l.17,48.11,18.42-.07-.16-48.11-18.42.07ZM1257.6,752.61l-16.03.06-.17-45.63,16.03-.05.18,45.63Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-35",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1244.34,711.48c.09-.13.17-.14.26-.27.03-.96.53-1.74,1.11-1.68l6.57.04c.57-.05,1.12.72,1.2,1.68.1.11.21.1.31.2.3,15.29.45,25.25-4.02,37.77-4.98-12.37-5.14-22.59-5.44-37.74Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-36"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-36",
  "data-name": "Back",
  className: "cls-31",
  x: 1242.18,
  y: 654.92,
  width: 15.77,
  height: 45.67,
  transform: "translate(-2.35 4.36)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-36",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1240.82,653.72l.16,48.15,18.11-.07-.16-48.15-18.12.07ZM1257.92,700.57l-15.77.06-.17-45.67,15.76-.05.18,45.67Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-36",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1244.88,659.39c.09-.13.17-.14.26-.27.03-.96.52-1.74,1.09-1.68l6.46.04c.56-.05,1.1.72,1.18,1.68.1.11.2.1.31.2.29,15.3.45,25.27-3.95,37.8-4.89-12.38-5.06-22.61-5.35-37.77Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-37"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-37",
  "data-name": "Back",
  className: "cls-31",
  x: 1242.08,
  y: 596.16,
  width: 15.87,
  height: 45.74,
  transform: "translate(-2.16 4.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-37",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1240.71,594.96l.17,48.22,18.23-.07-.16-48.22-18.23.07ZM1257.92,641.87l-15.87.06-.17-45.74,15.86-.05.18,45.73Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-37",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1244.79,600.64c.09-.13.17-.14.26-.27.03-.96.52-1.74,1.1-1.69l6.5.04c.57-.05,1.11.72,1.19,1.68.1.11.2.1.31.2.29,15.32.45,25.31-3.97,37.86-4.93-12.4-5.09-22.64-5.38-37.83Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-38"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-38",
  "data-name": "Back",
  className: "cls-31",
  x: 1265.43,
  y: 487.61,
  width: 45.74,
  height: 15.87,
  transform: "translate(34.8368 1073.5801) rotate(-45.796)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-38",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1298.5,471.84l-33.62,34.57,13.07,12.7,33.62-34.56-13.07-12.71ZM1277.97,517.4l-11.38-11.06,31.88-32.8,11.37,11.06-31.87,32.8Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-38",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1297.45,478.76c.16-.03.22.02.38,0,.69-.67,1.59-.88,1.96-.44l4.62,4.58c.44.36.28,1.29-.33,2.03,0,.15.07.22.08.36-10.51,11.15-17.39,18.4-29.33,24.27,5.16-12.3,12.2-19.74,22.62-30.79Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-39"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-39",
  "data-name": "Back",
  className: "cls-31",
  x: 1310.16,
  y: 442.04,
  width: 45.74,
  height: 15.87,
  transform: "translate(78.8359 1087.5013) rotate(-45.5975)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-39",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1343.31,426.3l-33.74,34.45,13.03,12.75,33.74-34.45-13.03-12.75ZM1322.62,471.79l-11.34-11.1,32-32.69,11.33,11.1-31.99,32.69Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-39",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1342.23,433.21c.16-.03.22.02.38,0,.69-.67,1.6-.87,1.96-.43l4.6,4.59c.44.36.28,1.29-.34,2.03,0,.15.07.22.08.36-10.55,11.12-17.45,18.34-29.41,24.17,5.2-12.29,12.27-19.69,22.73-30.71Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-40"
}, /*#__PURE__*/React.createElement("path", {
  id: "Berth-40",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1404.84,363.3l-33.74,34.45,13.03,12.75,33.74-34.45-13.03-12.75ZM1384.15,408.79l-11.34-11.1,32-32.69,11.33,11.1-31.99,32.69Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Back-40",
  "data-name": "Back",
  className: "cls-31",
  x: 1371.68,
  y: 379.04,
  width: 45.74,
  height: 15.87,
  transform: "translate(142.3229 1112.5399) rotate(-45.5975)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-40",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1403.76,370.21c.16-.03.22.02.38,0,.69-.67,1.6-.87,1.96-.43l4.6,4.59c.44.36.28,1.29-.34,2.03,0,.15.07.22.08.36-10.55,11.12-17.45,18.34-29.41,24.17,5.2-12.29,12.27-19.69,22.73-30.71Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "B-41"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Back-41",
  "data-name": "Back",
  className: "cls-31",
  x: 1416.22,
  y: 333.51,
  width: 45.74,
  height: 15.87,
  transform: "translate(188.2196 1130.6848) rotate(-45.5975)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Berth-41",
  "data-name": "Berth",
  className: "cls-9",
  d: "M1449.37,317.78l-33.74,34.45,13.03,12.75,33.74-34.45-13.03-12.75ZM1428.68,363.26l-11.34-11.1,32-32.69,11.33,11.1-31.99,32.69Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Boat-41",
  "data-name": "Boat",
  className: "cls-9",
  d: "M1448.29,324.69c.16-.03.22.02.38,0,.69-.67,1.6-.87,1.96-.43l4.6,4.59c.44.36.28,1.29-.34,2.03,0,.15.07.22.08.36-10.55,11.12-17.45,18.34-29.41,24.17,5.2-12.29,12.27-19.69,22.73-30.71Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Pedestals"
}, /*#__PURE__*/React.createElement("g", {
  id: "P-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin",
  className: "cls-10",
  d: "M1862.89,1176.83h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1862.67,1181.22s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1862.1,1181.22s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1862.68,1179.88c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1859.77,1180.52c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1862.34,1181.78c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1857.78,1178.09s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1857.48,1178.88h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1858.65,1181.54c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-2",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.21,1147.86h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-2",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1872,1152.25s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.43,1152.25s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1872.01,1150.91c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.09,1151.55c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.67,1152.81c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.11,1149.12s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.81,1149.91h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.97,1152.57c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-3",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.14,1099.55h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-3",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.92,1103.94s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.35,1103.94s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.93,1102.6c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.02,1103.25c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.6,1104.5c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.03,1100.82s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.74,1101.61h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.9,1104.27c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-4",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.11,1051.74h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-4",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.89,1056.13s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.32,1056.13s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.9,1054.79c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1868.99,1055.44c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.56,1056.69c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867,1053s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.7,1053.8h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.87,1056.45c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-5",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.14,1014.95h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-5",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.92,1019.34s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.35,1019.34s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.93,1018c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.02,1018.65c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.6,1019.9c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.03,1016.21s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.73,1017h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.9,1019.66c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-6",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.14,992.49h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-6",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.92,996.88s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.35,996.88s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.93,995.54c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.02,996.19c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.6,997.44c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.03,993.75s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.73,994.55h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.9,997.2c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-7",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.18,966.17h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-7",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.96,970.56s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.39,970.56s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.97,969.22c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.06,969.87c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.63,971.12c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.07,967.43s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.77,968.23h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.94,970.89c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-8",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1871.94,944.16h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-8",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.72,948.55s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.15,948.55s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.73,947.21c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1868.82,947.86c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.39,949.11c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1866.83,945.42s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.53,946.21h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1867.7,948.87c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-9"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-9",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1872.25,904.74h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-9",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1872.04,909.13s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.47,909.13s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1872.04,907.79c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1869.13,908.44c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1871.71,909.69c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1867.15,906s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1866.85,906.8h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1868.01,909.45c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-10"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-10",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1756.84,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-10",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1756.63,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1756.06,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1756.63,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1753.72,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1756.3,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1751.74,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1751.44,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1752.6,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-11"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-11",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1734.24,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-11",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1734.03,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1733.46,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1734.03,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1731.12,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1733.7,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1729.14,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1728.84,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1730,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-12"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-12",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1711.03,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-12",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1710.81,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1710.24,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1710.82,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1707.91,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1710.49,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1705.92,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1705.62,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1706.79,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-13"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-13",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1688.7,815.93h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-13",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1688.49,820.32s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1687.92,820.32s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1688.5,818.98c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1685.58,819.62c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1688.16,820.88c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1683.6,817.19s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1683.3,817.98h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1684.46,820.64c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-14"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-14",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1653.9,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-14",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1653.68,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1653.11,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1653.69,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1650.78,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1653.36,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1648.79,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1648.49,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1649.66,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-15"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-15",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1607.86,815.93h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-15",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1607.64,820.32s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1607.07,820.32s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1607.65,818.98c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1604.74,819.62c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1607.32,820.88c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1602.75,817.19s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1602.46,817.98h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1603.62,820.64c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-16"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-16",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1562.58,815.93h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-16",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1562.36,820.32s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1561.79,820.32s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1562.37,818.98c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1559.46,819.62c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1562.03,820.88c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1557.47,817.19s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1557.17,817.98h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1558.34,820.64c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-17"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-17",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1516.89,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-17",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1516.67,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1516.11,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1516.68,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1513.77,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1516.35,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1511.78,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1511.49,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1512.65,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-18"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-18",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1471.1,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-18",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1470.88,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1470.31,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1470.89,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1467.98,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1470.55,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1465.99,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1465.69,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1466.86,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-19"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-19",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1425.44,815.93h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-19",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1425.22,820.32s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1424.65,820.32s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1425.23,818.98c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1422.32,819.62c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1424.89,820.88c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1420.33,817.19s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1420.03,817.98h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1421.2,820.64c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-20"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-20",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1380.73,815.93h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-20",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1380.51,820.32s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1379.94,820.32s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1380.52,818.98c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1377.61,819.62c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1380.19,820.88c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1375.62,817.19s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1375.32,817.98h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1376.49,820.64c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-21"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-21",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1334.3,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-21",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1334.09,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1333.52,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1334.1,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1331.19,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1333.76,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1329.2,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1328.9,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1330.07,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-22"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-22",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1297.67,815.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-22",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1297.46,819.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1296.89,819.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1297.47,818.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1294.56,819.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1297.13,820.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1292.57,816.67s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1292.27,817.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1293.43,820.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-23"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-23",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1273.45,756.75h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-23",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1273.24,761.14s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1272.67,761.14s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1273.24,759.8c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1270.33,760.45c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1272.91,761.7c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1268.35,758.02s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1268.05,758.81h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1269.21,761.47c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-24"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-24",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1274.66,709.66h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-24",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.44,714.05s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1273.87,714.05s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.45,712.71c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1271.54,713.36c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.12,714.61c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1269.55,710.92s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1269.26,711.72h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1270.42,714.37c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-25"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-25",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1275.39,663.64h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-25",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1275.17,668.03s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.6,668.03s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1275.18,666.69c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1272.27,667.34c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.85,668.59c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1270.28,664.91s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1269.99,665.7h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1271.15,668.36c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-26"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-26",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1275.69,602.41h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-26",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1275.47,606.8s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1274.91,606.8s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1275.48,605.46c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1272.57,606.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1275.15,607.36c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1270.59,603.68s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1270.29,604.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1271.45,607.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-27"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-27",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1320.36,477.92h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-27",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1320.15,482.31s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1319.58,482.31s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1320.15,480.97c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1317.24,481.61c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1319.82,482.87c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1315.26,479.18s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1314.96,479.97h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1316.12,482.63c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-28"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-28",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1365.11,432.38h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-28",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1364.9,436.77s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1364.33,436.77s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1364.9,435.43c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1361.99,436.08c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1364.57,437.33c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1360.01,433.64s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1359.71,434.43h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1360.87,437.09c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-29"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-29",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1387.74,409.42h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-29",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1387.52,413.81s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1386.95,413.81s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1387.53,412.47c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1384.62,413.11c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1387.19,414.37c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1382.63,410.68s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1382.33,411.47h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1383.5,414.13c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "P-30"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-30",
  "data-name": "Pin",
  className: "cls-10",
  d: "M1432.19,363.88h0c-1.17-1.23-2.8-1.92-4.5-1.91h0c-1.7-.01-3.33.68-4.51,1.91-2.4,2.93-1.08,5.67-1.02,5.79h0c1.53,2.8,5.21,9.52,5.25,9.59.08.15.26.2.42.12.04-.02.08-.05.1-.1h0l5.28-9.6v-.02c.06-.12,1.38-2.86-1.02-5.79Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-30",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1431.97,368.27s.03.09.08.08h.04s.08-.03.08-.08h0v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1431.41,368.27s.03.08.09.08h.04s.09-.03.09-.08v-.32h-.21v.32h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1431.98,366.93c-.48-2.43-2.83-4.01-5.26-3.54-2.43.47-4.01,2.83-3.54,5.25.38,1.97,2.03,3.44,4.02,3.61.13.01.25.02.37.02,1.33,0,2.59-.59,3.45-1.61.15-.17.21-.39.18-.61-.03-.21-.17-.4-.35-.51-.21-.13-.45-.2-.69-.18-.36,0-.72.14-.98.41-.36.38-.96.4-1.35.04l-.05-.04c-.54-.55-1.4-.55-1.95-.02h0s-.01.02-.01.02c-.09.09-.2.16-.31.22-.11.04-.16.17-.11.28.05.11.17.16.29.11,0,0,.01,0,.02,0h0c.15-.07.28-.17.4-.29.37-.39.97-.41,1.35-.05h0s.03.03.05.05c.54.54,1.41.54,1.96,0h0c.18-.2.44-.31.71-.31.17,0,.33.03.46.13.08.04.13.12.15.21.02.09-.01.18-.08.26-1.43,1.72-3.99,1.95-5.71.51-1.72-1.43-1.95-3.99-.51-5.71,1.43-1.71,3.99-1.95,5.71-.52.7.58,1.18,1.38,1.36,2.26-.21.05-.35.24-.35.45v.46h1.16v-.45c0-.22-.16-.41-.37-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1429.07,367.58c0-.1-.09-.17-.18-.17-.1,0-.17.08-.17.18,0,.1.08.17.17.17.1,0,.18-.08.18-.17h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1431.65,368.83c-.12-.07-.24-.15-.34-.24-.25-.26-.61-.41-.98-.4-.18,0-.35.03-.51.1l.37-1.05c.02-.06.02-.13-.02-.18-.03-.06-.08-.1-.15-.1l-.88-.2v-.83c0-.17-.13-.31-.3-.31h-.24v-.46c0-.13-.11-.24-.24-.24h-.41v-.11c0-.06-.04-.12-.11-.12h-.18c-.06,0-.11.05-.11.12v.11h-.41c-.13,0-.24.11-.24.24v.46h-.24c-.17,0-.31.14-.31.31v.83l-.88.2c-.06,0-.12.04-.15.1-.03.05-.04.11-.02.18l.52,1.49c-.16.12-.35.18-.55.18-.12,0-.2.11-.2.23,0,.1.1.18.2.2.35,0,.7-.13.95-.38h0l.03-.03c.36-.39.96-.41,1.35-.05h0s.03.04.05.05c.53.54,1.4.54,1.94.01h.01c.36-.4.97-.42,1.36-.07.02.02.03.04.05.05.13.12.29.22.45.29.1.05.23,0,.28-.11.05-.1,0-.24-.1-.28h0v.02ZM1427.09,365.14s.02-.06.05-.06h1.22s.06.02.06.05h0v.46h-1.34v-.46h0ZM1426.79,365.93h1.94c.06-.01.12.03.13.1.01.07-.04.12-.1.13h-1.96c-.06.01-.12-.04-.13-.11,0-.06.03-.12.1-.13h.03ZM1427.95,368.59c-.25-.26-.6-.41-.97-.41-.28,0-.55.08-.78.24l-.39-1.11,1.94-.44,1.95.44-.49,1.38c-.16.14-.36.2-.57.2-.27,0-.52-.12-.7-.31Z"
})))));

function SvgOrganisation8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2665.64 1994.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation8);
export default __webpack_public_path__ + "static/media/Organisation_8.1a6302c0.svg";
export { ForwardRef as ReactComponent };